import React, {Component} from 'react';
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacategory,
    Image,
    KeyboardAvoidingView,
    Alert,
    TouchableOpacity, Text, I18nManager, BackHandler,
    Picker,
} from 'react-native';
import HMActionBar from '../../../customviews/HMActionBar';

const {width: SCREEN_WIDTH} = Dimensions.get('window');
import {moderateScale} from '../../../tools/Scaling';
import Colors, {colorDark, colorPrimary} from '../../../tools/Colors';
import HMTextView from '../../../customviews/HMTextView';

let container = null;

const WINDOW_WIDTH = Dimensions.get('window').width;
const BASE_PADDING = 10;

import store from '../../../redux/store';

const {width, height} = Dimensions.get('window');

let arrMenu = [];
const _Ages = [
    {
        id: 1,
        value: '1-18',
        label: '1-18',
    },
    {
        id: 2,
        value: '19-40',
        label: '19-40',
    },
    {
        id: 3,
        value: '41 به بالا',
        label: '41 به بالا',
    },


];
const _Educations = [
    {
        id: 1,
        value: 'ابتدایی',
        label: 'ابتدایی',
    },
    {
        id: 2,
        value: 'راهنمایی',
        label: 'راهنمایی',
    },
    {
        id: 3,
        value: 'دبیرستان',
        label: 'دبیرستان',
    },
    {
        id: 4,
        value: 'دیپلم',
        label: 'دیپلم',
    },
    {
        id: 5,
        value: 'فوق دیپلم',
        label: 'فوق دیپلم',
    },
    {
        id: 6,
        value: 'لیسانس',
        label: 'لیسانس',
    },
    {
        id: 7,
        value: 'فوق لیسانس',
        label: 'فوق لیسانس',
    },
    {
        id: 8,
        value: 'دکتر',
        label: 'دکتر',
    },

];
const theme = {
    title: '#FFF',
    more: '#446984',
    center: '#7B8F99',
    fullscreen: '#446984',
    volume: '#A5957B',
    scrubberThumb: '#234458',
    scrubberBar: '#DBD5C7',
    seconds: '#DBD5C7',
    duration: '#DBD5C7',
    progress: '#446984',
    loading: '#DBD5C7',
};

import {Tools} from '../../../tools/Tools';
import PathFile from '../../../assets/PathFile';
import i18n from '../../../I18n/i18n';
import HMListItemTitle from '../../../customviews/HMListItemTitle';
import * as NavigationService from '../../../redux/NavigationService';
import {typeExport} from '../../../redux/store/type';
import DialogConnectionCustomize from '../../../customviews/DialogConnectionCustomize';
import DialogLoadingCustomize from '../../../customviews/DialogLoadingCustomize';

import HMImageView from '../../../customviews/HMImageView';
import HMVideo from '../../../customviews/video/HMVideo';

import HMTextInputEfects from '../../../customviews/HMTextInputEfects';
import HMSelectInput from '../../../customviews/HMSelectInput';
import HMListCheckBox from '../../../customviews/HMListCheckBox';
import axios from 'axios';
import {AsyngStorageClass} from '../../../tools/AsyngStorageClass';
import {
    serviceActionChangeState,
    serviceActionListFilter,
} from './action/ActionListOperatorFireApplysScreen';
import Popup from '../../../tools/mapLink/components/Popup';
import EmptyView from '../../../customviews/empty/EmptyView';
import moment from 'moment-jalaali';
import HMDetailsMap from '../../../customviews/HMDetailsMap';
import HMIcon from '../../../customviews/HMIcon';
import HMMap1 from '../../../customviews/map/HMMap';
import HMModal from '../../../customviews/modal/HMModal';
import HMSwiper from '../../../customviews/swiper/HMSwiper';
import HMAlert from '../../../customviews/HMAlert';
import HMLoading from '../../../customviews/HMLoading';
import WebViewScreen from '../../common/webview/WebViewScreen';

var sound = null;

let itemParams = null;

export default class DetailsOperatorFireApplyScreen extends Component {


    static navigationOptions = ({navigation}) => {
        const {state} = navigation;
        // Setup the header and tabBarVisible status
        const header = state.params && (state.params.fullscreen ? undefined : null);
        const tabBarVisible = state.params ? state.params.fullscreen : true;
        return {
            // For stack navigators, you can hide the header bar like so
            header,
            // For the tab navigators, you can hide the tab bar like so
            tabBarVisible,
        };
    };

    constructor(props) {
        super(props);
        container = this;
        itemParams = props.route.params.item;
        let viewportWidth = 1;
        let viewportHeight = 1;
        let columnCount = 1;
        if (Platform.OS === 'web') {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;
            columnCount = viewportWidth > 1000 ? 2 : 1;

        }
        //    let item = props.route.params.item;
        arrMenu = props.route.params.offline ?
            [
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 1,
                    card: true, status: true, login: true,
                    type: 1,
                    name: 'ثبت زمان رسیدن',
                    title: 'ثبت زمان رسیدن',
                    thumbnail: PathFile.image.fire_symbol,
                    width: '4.1',
                    disable: true,
                },
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 2,
                    card: true, status: false, login: true, type: 2,
                    name: 'ثبت زمان اطفای حریق',
                    title: 'ثبت زمان اطفای حریق',
                    thumbnail: PathFile.image.fire_clock,
                    width: '4.1',
                    disable: true,
                },
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 3,
                    card: true, status: true, login: true, type: 3,
                    name: 'ثبت زمان بازگشت',
                    title: 'ثبت زمان بازگشت',
                    thumbnail: PathFile.image.fire_clock2,
                    width: '4.1',
                    disable: true,
                },
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 4,
                    card: true, status: false, login: true, type: 4,
                    name: 'ثبت فایل',
                    title: 'ثبت فایل',
                    thumbnail: PathFile.image.fire_file,
                    width: '4.1',
                    disable: true,
                },
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 5,
                    card: true, status: true, login: true, type: 5,
                    name: 'مشخصات ملک',
                    title: 'مشخصات ملک',
                    thumbnail: PathFile.image.fire_weather,
                    width: '4.1',
                },
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 6,
                    card: true, status: true, login: true, type: 6,
                    name: 'حادثه دیدگان',
                    title: 'حادثه دیدگان',
                    thumbnail: PathFile.image.fire_shape,
                    width: '4.1',
                },
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 7,
                    card: true, status: false, login: true, type: 7,
                    name: 'توضیحات تکمیلی',
                    title: 'توضیحات تکمیلی',
                    thumbnail: PathFile.image.fire_remove,
                    width: '4.1',
                },
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 8,
                    card: true, status: false, login: true, type: 8,
                    name: 'لوازم مصرفی حادثه',
                    title: 'لوازم مصرفی حادثه',
                    thumbnail: PathFile.image.fire_extinguisher,
                    width: '4.1',
                },
            ]
            :
            [
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 1,
                    card: true, status: true, login: true,
                    type: 1,
                    name: 'ثبت زمان رسیدن',
                    title: 'ثبت زمان رسیدن',
                    thumbnail: PathFile.image.fire_symbol,
                    width: '4.1',
                },
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 2,
                    card: true, status: false, login: true, type: 2,
                    name: 'ثبت زمان اطفای حریق',
                    title: 'ثبت زمان اطفای حریق',
                    thumbnail: PathFile.image.fire_clock,
                    width: '4.1',
                },
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 3,
                    card: true, status: true, login: true, type: 3,
                    name: 'ثبت زمان بازگشت',
                    title: 'ثبت زمان بازگشت',
                    thumbnail: PathFile.image.fire_clock2,
                    width: '4.1',
                },
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 4,
                    card: true, status: false, login: true, type: 4,
                    name: 'ثبت فایل',
                    title: 'ثبت فایل',
                    thumbnail: PathFile.image.fire_file,
                    width: '4.1',
                }, {
                background_color: '#ffffff',
                create_at: '2018-11-05 20:09:44',
                font_color: '#333333',
                height: '3.3',
                id: 5,
                card: true, status: false, login: true, type: 5,
                name: 'مشخصات ملک',
                title: 'مشخصات ملک',
                thumbnail: PathFile.image.fire_weather,
                width: '4.1',
            },
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 6,
                    card: true, status: false, login: true, type: 6,
                    name: 'حادثه دیدگان',
                    title: 'حادثه دیدگان',
                    thumbnail: PathFile.image.fire_shape,
                    width: '4.1',
                },
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 7,
                    card: true, status: false, login: true, type: 7,
                    name: 'توضیحات تکمیلی',
                    title: 'توضیحات تکمیلی',
                    thumbnail: PathFile.image.fire_remove,
                    width: '4.1',
                },
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 8,
                    card: true, status: false, login: true, type: 8,
                    name: 'لوازم مصرفی حادثه',
                    title: 'لوازم مصرفی حادثه',
                    thumbnail: PathFile.image.fire_extinguisher,
                    width: '4.1',
                },
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 10,
                    card: true, status: false, login: true, type: 10,
                    name: 'تایید عملیات',
                    title: 'تایید عملیات',
                    thumbnail: PathFile.image.ok,
                    width: '4.1',
                },
                {
                    background_color: '#ffffff',
                    create_at: '2018-11-05 20:09:44',
                    font_color: '#333333',
                    height: '3.3',
                    id: 9,
                    card: true, status: false, login: true, type: 9,
                    name: 'مسیریابی نشان',
                    title: 'مسیریابی نشان',
                    thumbnail: PathFile.image.neshan,
                    sourceImage: PathFile.image.neshan,
                    width: '4.1',

                },
            ];

        let {files, video, audio, image} = props.route.params.item;

        let checkAudio = audio || audio === null ? audio : (files && files.length > 0 && (files.find(k => k.type === 'audio/aac')) && (files.find(k => k.type === 'audio/aac')).file);
        let checkImage = image || image === null ? image : (files && files.length > 0 && (files.find(k => k.type === 'image/jpeg')) && (files.find(k => k.type === 'image/jpeg')).file);
        let checkVideo = video || video === null ? video : (files && files.length > 0 && (files.find(k => k.type === 'video/mp4')) && (files.find(k => k.type === 'video/mp4')).file);
        this.state = {


            columnCount: columnCount,
            viewportWidth: viewportWidth,
            itemWidth: Platform.OS === 'web' ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,

            showListModal: false,
            TypeBuildingList: [],
            EquipmentItemList: [],

            services: ['aa', 'bb', 'cc', 'dd', 'ee'],
            selectedService: 'a',
            slider1ActiveSlide: 0,
            modalHeight: 0,
            isFull: false,

            FinalList: [],


            listVideo: [],
            listImage: [],
            listVoice: [],
            listOthers: [],

            // listOthersTasks: [],


            ShowImage: false,
            ShowVideo: false,
            visibleModal: '',
            visibleModalMenu: '',
            playSeconds: 0.0,
            playState: 'playing',

            index: 0,
            setIndex: 0,
            routes: [
                {key: 'first', title: 'وظیفه'},
                {key: 'second', title: i18n.t('constant.Information')},
                {key: 'third', title: i18n.t('constant.MessageCirculation')},
            ],

            pathAudio: checkAudio,
            pathVideo: checkVideo,

            ItemTask: this.props.route.params.offline ? this.props.route.params.listTask[this.props.route.params.index] : props.route.params.item,
            ListTask: this.props.route.params.offline ? this.props.route.params.listTask : [],
            UserAgentList: [],

            indexSelectCheckBoxtype: 0,
            indexSelectCheckBoxInjuryType: 1,

        };


        if (files) {
            for (let i = 0; i < files.length; i++) {
                let f = String(files[i].type);

                if (f.search('audio/') >= 0) {
                    this.state.listVoice.push(files[i]);
                } else if (f.search('image/') >= 0) {
                    this.state.listImage.push(files[i]);
                } else if (f.search('video/') >= 0) {
                    this.state.listVideo.push(files[i]);
                } else {

                    this.state.listOthers.push(files[i]);

                }

            }
        }


        //  this.onFullScreen = this.onFullScreen.bind(this);// you should bind this to the method that call the props
        this.props.navigation.addListener('focus', () => {
                if (global.onRefreshDetailsOperatorFireApplyScreen) {
                    global.onRefreshDetailsOperatorFireApplyScreen = false;
                    // store.dispatch(serviceActionListFilter([]))
                    // props.callserviceActionRefresh();
                    this.changeState();

                    if (container.state.idMenu == 4) {
                        container.getServerFiles();

                    }
                    //  this.getData()
                }
                /*   store.dispatch(serviceActionListFilter([]))
                   props.callserviceActionRefresh();
                   this.getData(1)*/
            },
        );
        this.props.navigation.addListener('blur', () => {

            },
        );
    }


    _onRef = (property, view) => {
        container[property] = view;
    };

    _focusNextField(nextField) {
        //  console.log("nextField", container[nextField])
        // console.log(this[nextField])
        container[nextField].focus();
        // container[nextField].input.current.measureLayout(
        //     ReactNative.findNodeHandle(container._scroll),
        //     (x, y) => {
        //         container._scroll.scrollTo({x: 0, y: y - moderateScale(40), animated: true});
        //     }
        // );
    }

    getData() {
        let paramss = {

            //"_operation": typeExport._Fire,
            //'mode': typeExport._GetCsStatus,
            '_session': store.getState().reducerSplashGetAllData.token,
            'RequestID': itemParams.RequestID,
            'teamID': itemParams.TeamID,
            'state_params': this.props.route.params,
            'lang': i18n.locale,

        };
        // this.props.callService(urlGetAllData, `?lang=${i18n.locale}&token=${token}&token_fb=${token_fb}`, TypeGetAllData, 'POST', token, token_fb, imageBack)
        this.props.callService(typeExport._baseUrl125, paramss, typeExport.TypeGetDetailsOperatorFireApplyScreen, typeExport._POST, store.getState().reducerSplashGetAllData.token);
    }


    /////////////////////////
    hiddenModal(type) {
        //this._stop()
        if (sound) {
            this.setState({
                    playState: 'playing',

                },
                () => {

                });

            this._pause();

        }
        type ?

            this.setState({
                    visibleModalMenu: '',

                    errorSelectInput: false, errorModal: false,
                    sliderList: [],
                },
                () => {
                    // Orientation.unlockAllOrientations();
                    // Orientation.lockToPortrait();
                })
            :
            this.setState({
                    visibleModal: '',
                    visibleModalMenu: 'selectMenu',
                    errorSelectInput: false, errorModal: false,
                    sliderList: [],
                },
                () => {
                    // Orientation.unlockAllOrientations();
                    // Orientation.lockToPortrait();
                });
    }

    onShow(data) {
        this.setState({
            visibleModal: data,
            Modalcategory: true,

        });
    }


    async onFlyToPress(long, lat) {
        if (Platform.OS === 'web') {
            //this.map.leafletElement.flyTo(c, 20, this.getZoomPanOptions())
            this.map.mapRef.current.flyTo([lat, long], 18);

        }
        else {
            const camera = await this.map.mapRef.current.getCamera();

            camera.zoom = 17;
            camera.center.latitude = lat;
            camera.center.longitude = long;
            this.map.mapRef.current.animateCamera(camera, {duration: 2000});
            // this.onFlyToComplete();
        }
    }


    componentWillReceiveProps(propss) {


    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true});
    }

    async componentDidMount() {
        if (Platform.OS === 'web') {
            window.addEventListener('resize', function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 1000 ? 2 : 1,
                    },
                );


            });
        }

        this.setState({
            // dataSourcearraycategory: this.state.arraycategory,
            // dataSourcearrayBedrooms: this.state.arrayBedrooms
        });


    }

    componentWillMount() {
        let {title, description, latitude, longitude, address, code, status, files, createdtime, comment} = this.props.route.params.item;
        //   let checkVideo = files && files.length > 0 ? files.find(k => k.type === 'video/mp4') : false;
        //  let checkImage = files && files.length > 0 ? files.find(k => k.type === 'image/jpeg') : false;
        BackHandler.addEventListener('hardwareBackPress', this.handleBackButton);
    }

    componentWillUnmount() {
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackButton);

        if (sound) {
            sound.release();
            sound = null;
        }
        if (this.timeout) {
            clearInterval(this.timeout);
        }

    }

    handleBackButton = () => {

        if (this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectSlider') {
            this.setState({
                visibleModal: '',
                visibleModalMenu: '',
            });
        } else {
            this.props?.navigation?.pop();
        }

        return true;
    };

    render() {

        let {setIndex, routes, index, slider1ActiveSlide} = this.state;


        let {title, description, Latitude: latitude, Longitude: longitude, Address: address, code, status, files, createdtime, comment, video, audio, image, subject, DateTimeJalali: date, category} = this.props.results ? this.props.results : this.state.ItemTask;
        let item = this.props.results ? this.props.results : this.state.ItemTask;
        let heightSlider = (this.state.viewportWidth > 600) ? 420 : (Platform.OS === 'web' ? this.state.viewportWidth : typeExport.WIDTH) / 1.6;
        let widthCategory = Platform.OS === 'web' ? (this.state.viewportWidth > 600 ? 580 : this.state.viewportWidth) : typeExport.WIDTH;
        let {ListOperatorFireApplyScreen} = this.props;
        let results = this.props.route.params.offline ? this.state.ItemTask : ListOperatorFireApplyScreen.results[this.props.route.params.index];
        return (
            <View style={{flex: 1}}>
                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>

                    <KeyboardAvoidingView style={{width: '100%', height: '100%'}} behavior={'padding'}
                                          enabled={Platform.OS === 'ios'}>


                        <View
                            style={{flex: 1, position: 'relative'}}>
                            <HMActionBar menu
                                         props={this.props} statusBarTransparent
                                //   text={i18n.t('Privatizations.title')}
                                         text={i18n.t('constant.Details')}
                                         headerVisibility
                                         more_menu
                                         back
                                         onBackPress={() => this.props.navigation.pop()}

                            />


                            <ScrollView>
                                <View style={{flex: 1}}>
                                    {
                                        latitude && latitude != null && latitude != '' && latitude != 0 ?
                                            <View>
                                                <View
                                                    style={{width: '100%', height: heightSlider, overflow: 'hidden'}}
                                                >
                                                    <HMMap1
                                                        ref={ref => (this.map = ref)}
                                                        //   provider={PROVIDER_GOOGLE} // remove if not using Google Maps
                                                        showPlace
                                                        provider="google"


                                                        style={{
                                                            width: '100%',
                                                            //height:height-moderateScale(200),
                                                            height: '100%', marginBottom: this.state.marginBottom,
                                                        }}
                                                        initialRegion={{
                                                            latitude: parseFloat(latitude),
                                                            longitude: parseFloat(longitude),
                                                            latitudeDelta: 0.015,
                                                            longitudeDelta: 0.0121,
                                                        }}
                                                        coordinate={{
                                                            latitude: parseFloat(latitude),
                                                            longitude: parseFloat(longitude),
                                                            latitudeDelta: 0.015,
                                                            longitudeDelta: 0.0121,
                                                        }}
                                                    />


                                                    {
                                                        // address ?
                                                        1 === 1 ?
                                                            <TouchableOpacity
                                                                onPress={() => this.onFlyToPress(parseFloat(longitude), parseFloat(latitude))}
                                                                style={{
                                                                    flexDirection: 'row',
                                                                    padding: moderateScale(5),
                                                                    //     justifyContent: "flex-end",
                                                                    alignItems: 'center',
                                                                    width: '100%',
                                                                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                                                    position: 'absolute',
                                                                    bottom: 0,
                                                                    left: 0,
                                                                }}>
                                                                <HMIcon type={'Feather'} name={'map-pin'}
                                                                        style={{
                                                                            marginEnd: moderateScale(10),
                                                                            fontSize: moderateScale(22),
                                                                            color: Colors.white,
                                                                        }}/>
                                                                <HMTextView

                                                                    type={'bold'}

                                                                    style={{
                                                                        fontSize: moderateScale(12),
                                                                        color: Colors.light3,

                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    //text={'اراک خ هپکو خ امام حسین'}
                                                                    text={address}
                                                                    //   text={"98/03/21"}
                                                                />

                                                            </TouchableOpacity>
                                                            :
                                                            null
                                                    }

                                                    <TouchableOpacity

                                                        onPress={() => {
                                                            // Platform.OS === 'android' ?
                                                            //     Tools.GoLink(`geo:${latitude},${longitude}`)
                                                            //     :

                                                            this.setState({
                                                                /*   lat: this.state.regionFeature ? this.state.regionFeature.geometry.coordinates[1] : this.state.lat,
                                                                   long: this.state.regionFeature ? this.state.regionFeature.geometry.coordinates[0] : this.state.long, */

                                                                lat: latitude,
                                                                long: longitude,
                                                                isVisible: true,
                                                            });
                                                        }}
                                                        style={{
                                                            position: 'absolute',
                                                            margin: moderateScale(4),
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            top: 0,
                                                            right: 0,
                                                            height: moderateScale(30),
                                                            width: moderateScale(30),
                                                            borderRadius: moderateScale(15),
                                                            backgroundColor: Colors.colorPrimary,
                                                        }}>
                                                        <HMIcon
                                                            //  type={"FontAwesome5"}
                                                            name={'md-map-sharp'}
                                                            style={{
                                                                fontSize: moderateScale(18),
                                                                color: Colors.white,
                                                                textAlign: 'center',
                                                                padding: moderateScale(4),

                                                            }}/>

                                                    </TouchableOpacity>

                                                </View>
                                                <HMDetailsMap position={{latitude: latitude, longitude: longitude}}/>
                                            </View>
                                            : null
                                    }
                                    <View style={{marginVertical: moderateScale(6)}}>
                                        <View
                                            style={{
                                                //position:'absolute',
                                                flexDirection: 'row',
                                                flexWrap: 'wrap',
                                                // flex: 1,
                                                flexGrow: 1,
                                                alignItems: 'center', justifyContent: 'center',
                                                //  backgroundColor: _main ? "#eee" : Colors.transparent,
                                                //  backgroundColor: "#876a79",
                                            }}>


                                            {
                                                arrMenu.map((item, key) => {


                                                        let stateMenu = null;
                                                        let date = null;
                                                        let disableFlag = null;
                                                        let StateInformation = false;
                                                        let StateMelkDetail = false;
                                                        let CountValue = 0;
                                                        let CountDamage = 0;
                                                        let CountTools = 0;
                                                        let CountAnswers = 0;
                                                        if (results) {
                                                            switch (item.id) {
                                                                case 1:
                                                                    stateMenu = results.ReachTimeState;
                                                                    date = results.ReachTime;
                                                                    disableFlag = item.disable ? item.disable : results.disableFlag;
                                                                    break;
                                                                case 2:
                                                                    stateMenu = results.FireTimeState;
                                                                    date = results.FireTime;
                                                                    disableFlag = item.disable ? item.disable : !(results.Fire === true);

                                                                    break;
                                                                case 3:
                                                                    stateMenu = results.ReturnTimeState;
                                                                    date = results.ReturnTime;
                                                                    disableFlag = item.disable ? item.disable : results.disableFlag;

                                                                    break;
                                                                case 4:

                                                                    CountAnswers = results.CountAnswers;
                                                                    CountValue = results.CountAnswers;
                                                                    stateMenu = CountAnswers && CountAnswers > 0;

                                                                    // disableFlag = results.disableFlag;
                                                                    break;
                                                                case 5:
                                                                    stateMenu = results.StateMelkDetail;
                                                                    // date = results.FireTime;
                                                                    // disableFlag = !(results.Fire === true);

                                                                    break;
                                                                case 6:
                                                                    CountDamage = results.CountDamage;
                                                                    CountValue = results.CountDamage;
                                                                    stateMenu = CountDamage && CountDamage > 0;

                                                                    // stateMenu = results.ReturnTimeState;
                                                                    // date = results.ReturnTime;
                                                                    // disableFlag = results.disableFlag;

                                                                    break;
                                                                case 7:
                                                                    stateMenu = results.StateInformation;
                                                                    // date = results.ReturnTime;
                                                                    // disableFlag = results.disableFlag;

                                                                    break;
                                                                case 8:
                                                                    CountTools = results.CountTools;
                                                                    CountValue = results.CountTools;
                                                                    stateMenu = CountTools && CountTools > 0;

                                                                    // disableFlag = results.disableFlag;
                                                                    break;

                                                                case 10:

                                                                    stateMenu = results.StateConfirmOperation;

                                                                    // disableFlag = results.disableFlag;
                                                                    break;


                                                                default:
                                                                    // stateMenu = false;
                                                                    // date = null;
                                                                    // disableFlag = null;

                                                                    break;

                                                            }
                                                        }
                                                        //  (this.state.data).find((obj) => obj.locale == i18n.locale).list.map((item, key) => {
                                                        // let obj = {flag: false}
                                                        // this.state.loaded.push(obj)
                                                        return (
                                                            <TouchableOpacity
                                                                key={key}
                                                                onPress={() => {

                                                                    if (!disableFlag) {
                                                                        let formData = null;

                                                                        //alert(item.type)
                                                                        let type = parseFloat(item.type);
                                                                        this.setState({
                                                                                showListModal: false,

                                                                                typeMenu: type,
                                                                                idMenu: item.id,
                                                                                // visibleModalMenu: (type === 5 || type === 6 || type === 7 || type === 8) ? "selectMenu" : "",
                                                                                //  visibleModalMenu: (type === 7 ) ? "selectMenu" : "",

                                                                            },
                                                                            () => {
                                                                                switch (type) {

                                                                                    case 0 :

                                                                                        break;


                                                                                    case 1 :

                                                                                    case 2 :

                                                                                    case 3 :
                                                                                        HMAlert(i18n.t('constant.message'),
                                                                                            //   i18n.t('constant.selectCategory'),
                                                                                            i18n.t('constant.DoYouWantTo') + arrMenu[item.type - 1].title + i18n.t('constant.?'),
                                                                                            [
                                                                                                // {text: 'Ask me later', onPress: () => {}},
                                                                                                {
                                                                                                    text: i18n.t('constant.Yes'),
                                                                                                    onPress: () => {
                                                                                                        formData = new FormData();
                                                                                                        formData.append('lang', i18n.locale);
                                                                                                        formData.append('token', store.getState().reducerSplashGetAllData.token);
                                                                                                        formData.append('record', itemParams.RequestID);
                                                                                                        formData.append('teamid', itemParams.TeamID);
                                                                                                        formData.append('device', global._Device ? global._Device.value : null);


                                                                                                        switch (parseFloat(item.type)) {
                                                                                                            case 1 :
                                                                                                                // formData.append('_operation', checkType ? typeExport._Shahrdar : typeExport._Registration);
                                                                                                                // formData.append('mode', checkType ? typeExport._GetMenuShahrdar : typeExport._GetSubjects);
                                                                                                                formData.append('_operation', typeExport._Fire);
                                                                                                                formData.append('mode', 'SetTimeReach');


                                                                                                                this.requestServer(
                                                                                                                    formData, container.changeState,
                                                                                                                );
                                                                                                                break;

                                                                                                            case 2 :
                                                                                                                // formData.append('_operation', checkType ? typeExport._Shahrdar : typeExport._Registration);
                                                                                                                // formData.append('mode', checkType ? typeExport._GetMenuShahrdar : typeExport._GetSubjects);
                                                                                                                formData.append('_operation', typeExport._Fire);
                                                                                                                formData.append('mode', 'SetTimeFireoff');
                                                                                                                // formData.append('lang', i18n.locale);
                                                                                                                // formData.append('token', store.getState().reducerSplashGetAllData.token);
                                                                                                                // formData.append('record', itemParams.RequestID);
                                                                                                                // formData.append('teamid', itemParams.TeamID);


                                                                                                                this.requestServer(
                                                                                                                    formData, container.changeState,
                                                                                                                );
                                                                                                                break;

                                                                                                            case 3 :
                                                                                                                // formData.append('_operation', checkType ? typeExport._Shahrdar : typeExport._Registration);
                                                                                                                // formData.append('mode', checkType ? typeExport._GetMenuShahrdar : typeExport._GetSubjects);
                                                                                                                formData.append('_operation', typeExport._Fire);
                                                                                                                formData.append('mode', 'SetTimeReturn');
                                                                                                                // formData.append('lang', i18n.locale);
                                                                                                                // formData.append('token', store.getState().reducerSplashGetAllData.token);
                                                                                                                // formData.append('record', itemParams.RequestID);
                                                                                                                // formData.append('teamid', itemParams.TeamID);


                                                                                                                this.requestServer(
                                                                                                                    formData, container.changeState,
                                                                                                                );
                                                                                                                break;
                                                                                                        }
                                                                                                    },
                                                                                                },
                                                                                                {
                                                                                                    text: i18n.t('constant.No'),
                                                                                                    onPress: () => {
                                                                                                    },
                                                                                                    style: 'cancel',
                                                                                                },

                                                                                            ],
                                                                                            {cancelable: true},
                                                                                        );

                                                                                        break;


                                                                                    case 4 :
                                                                                        this.setState({
                                                                                            visibleModalMenu: 'selectMenu',
                                                                                            isLoadingModal: true,
                                                                                        });
                                                                                        //   NavigationService.navigateParams("SubmitRequestOperationFireScreen", {item: this.props.route.params.item})
                                                                                        this.getServerFiles();
                                                                                        break;

                                                                                    case 5 :
                                                                                        this.setState({
                                                                                            visibleModalMenu: 'selectMenu',
                                                                                            isLoadingModal: true,
                                                                                        });
                                                                                        this.getServerTypeBuilding();
                                                                                        break;
                                                                                    /* if (store.getState().reducerSplashGetAllData.token != null) {
                                                                                         NavigationService.navigateParams("ApplyScreen", {item,})
                                                                                         // NavigationService.navigateParams("ManInjamScreen", {item,})

                                                                                     } else {
                                                                                         store.dispatch(serviceActionSetState({
                                                                                             type: "ApplyScreen",
                                                                                             item: item
                                                                                         }))
                                                                                         NavigationService.navigateParams('LoginEnterPhoneScreen')

                                                                                     }*/


                                                                                    case 6 :
                                                                                        this.setState({
                                                                                            visibleModalMenu: 'selectMenu',
                                                                                            isLoadingModal: true,
                                                                                        });


                                                                                        this.getServerUserAgents();
                                                                                        this.getServerDamages();

                                                                                        // formData = new FormData();
                                                                                        //
                                                                                        // formData.append('_operation', typeExport._Fire);
                                                                                        // formData.append('mode', "GetEquipmentItem");
                                                                                        // formData.append('lang', i18n.locale);
                                                                                        // formData.append('token', store.getState().reducerSplashGetAllData.token);
                                                                                        //
                                                                                        // this.requestServer(
                                                                                        //     formData, (item) => this.setState({TypeBuildingList: item.result && item.result.list && item.result.list.length > 0 ? item.result.list : []}, () => {
                                                                                        //         //alert(item.success)
                                                                                        //     })
                                                                                        // );
                                                                                        break;

                                                                                    case 7 :
                                                                                        this.setState({
                                                                                            visibleModalMenu: 'selectMenu',
                                                                                            isLoadingModal: true,
                                                                                        });
                                                                                        this.getServerAdditionalInformation();


                                                                                        // NavigationService.navigateParams("ShowMap", {
                                                                                        //     myLocation: true,
                                                                                        //     item: item
                                                                                        // })

                                                                                        break;


                                                                                    case 8 :
                                                                                        this.setState({
                                                                                            visibleModalMenu: 'selectMenu',
                                                                                            isLoadingModal: true,
                                                                                        });
                                                                                        this.getServerEquipmentItem();
                                                                                        /*    NavigationService.navigateParams("ShowMap", {
                                                                                                myLocation: true,
                                                                                                item: item
                                                                                            })
        */
                                                                                        // this.getServerEquipmentItem()
                                                                                        break;

                                                                                    case 9 :
                                                                                        Tools.GoLinkMap(parseFloat(latitude), parseFloat(longitude));
                                                                                        //        // If it's an iPhone..
                                                                                        //        if (Platform.OS === "ios" || (navigator.platform.indexOf("iPhone") != -1) || (navigator.platform.indexOf("iPod") != -1) || (navigator.platform.indexOf("iPad") != -1))
                                                                                        //           // window.open(`maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=[${parseFloat(latitude)}],[${parseFloat(longitude)}]`);
                                                                                        //            window.open(`maps://map.neshan.org/?@${parseFloat(latitude)},${parseFloat(longitude)}`);
                                                                                        //        else
                                                                                        //        //  window.open(`https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=[${parseFloat(latitude)}],[${parseFloat(longitude)}]`);
                                                                                        //           // window.open('http://maps.google.com?daddr=' + parseFloat(latitude) + ',' + parseFloat(longitude) + '&amp;ll=');
                                                                                        //            window.open(`http://map.neshan.org/?@${parseFloat(latitude)},${parseFloat(longitude)}`);
                                                                                        //        //window.open('http://maps.google.com?daddr=' + parseFloat(latitude) + ',' + parseFloat(longitude) + '&amp;ll=', '_top').focus();
                                                                                        break;
                                                                                    case 10 :
                                                                                        this.setState({
                                                                                            visibleModalMenu: 'selectMenu',

                                                                                        });
                                                                                        break;


                                                                                    default:
                                                                                        Tools.showAlertUpdateApp();
                                                                                }

                                                                            },
                                                                        );
                                                                    }


                                                                }}
                                                                style={{
                                                                    width: item.width ? (widthCategory / parseFloat(item.width == 0 ? 3.2 : item.width)) : widthCategory / moderateScale(1),
                                                                    height: item.height ? (widthCategory / parseFloat(item.height == 0 ? 3.2 : item.height)) : widthCategory / moderateScale(3.6),
                                                                    // height: moderateScale(300),
                                                                    // padding: moderateScale(3),
                                                                    //  backgroundColor: disableFlag ? "#eee" : Colors.transparent,
                                                                    marginVertical: moderateScale(1),
                                                                    marginHorizontal: moderateScale(1),
                                                                    // marginBottom: moderateScale(1),
                                                                }}

                                                            >

                                                                <View
                                                                    style={{

                                                                        position: 'absolute',
                                                                        top: 0,
                                                                        bottom: 0,
                                                                        right: 0,
                                                                        left: 0,
                                                                        zIndex: 10,


                                                                    }}>
                                                                    <HMImageView
                                                                        card={true}
                                                                        resizeMode={'contain'}
                                                                        _backgroundColorLoading={Colors.transparent}
                                                                        borderRadius={4}
                                                                        // uriComplete={BaseUrliImage + item.imageUrl}
                                                                        item={item}

                                                                        //  uriComplete={item.thumbnail}
                                                                        source_image={item.thumbnail}

                                                                        text={(item.title ? item.title : '')}
                                                                        styleText={{
                                                                            textAlign: 'center',
                                                                            color: item.font_color ? item.font_color : Colors.gray,
                                                                            fontSize: title ? moderateScale(12) : moderateScale(12),

                                                                        }}
                                                                        styleImageRoot={{
                                                                            height: '50%',
                                                                            width: '50%',
                                                                            alignSelf: 'center',

                                                                        }}
                                                                        tintColor={item.id !== 9 && Colors.colorSecondPrimary}
                                                                        imageChild={stateMenu ? PathFile.image.Check : null}

                                                                    />
                                                                </View>

                                                                <View
                                                                    style={{

                                                                        position: 'absolute',
                                                                        top: 0,
                                                                        // left: 0,
                                                                        // marginH: moderateScale(2),
                                                                        //  width: moderateScale(15),
                                                                        // height: moderateScale(15),
                                                                        zIndex: 12,
                                                                        // backgroundColor:'#8dee34',
                                                                        alignSelf: 'center',

                                                                    }}>
                                                                    <HMTextView


                                                                        //   type={"bold"}

                                                                        style={{
                                                                            fontSize: moderateScale(14),
                                                                            color: Colors.colorDarkText,
                                                                            // lineHeight: moderateScale(14),

                                                                            //textAlign: 'center',
                                                                            // marginTop: moderateScale(10)
                                                                        }}
                                                                        //text={i18n.t('constant.MessageCirculation')}
                                                                        text={date}
                                                                    />
                                                                </View>
                                                                {
                                                                    item.id == 4 || item.id == 6 || item.id == 8 ?
                                                                        <View
                                                                            onPress={() => {

                                                                            }}

                                                                            style={{
                                                                                width: moderateScale(22),
                                                                                height: moderateScale(22),
                                                                                backgroundColor: '#ee005b',
                                                                                margin: moderateScale(3),
                                                                                position: 'absolute',
                                                                                borderRadius: moderateScale(11),
                                                                                top: 0,
                                                                                right: 0,
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                zIndex: 15,
                                                                            }}>

                                                                            <HMTextView


                                                                                //   type={"bold"}

                                                                                style={{
                                                                                    fontSize: moderateScale(13),
                                                                                    color: Colors.white,
                                                                                    //textAlign: 'center',
                                                                                    // marginTop: moderateScale(10)
                                                                                }}
                                                                                //   text={i18n.t('constant.MessageCirculation')}
                                                                                //   text={item.id == 6 ? CountDamage : item.id == 8 ? CountTools : CountAnswers}
                                                                                text={CountValue}
                                                                            />
                                                                        </View>
                                                                        :
                                                                        null
                                                                }

                                                                {
                                                                    !disableFlag ?
                                                                        null
                                                                        :
                                                                        <View
                                                                            style={{

                                                                                position: 'absolute',
                                                                                top: 0,
                                                                                left: 0,
                                                                                right: 0,
                                                                                bottom: 0,
                                                                                // marginH: moderateScale(2),
                                                                                //  width: moderateScale(15),
                                                                                // height: moderateScale(15),
                                                                                zIndex: 13,
                                                                                backgroundColor: 'rgba(0,0,0,0.2)',
                                                                                alignSelf: 'center',

                                                                            }}>

                                                                        </View>
                                                                }


                                                            </TouchableOpacity>
                                                        ); //if you have a bunch of keys value pair

                                                    },
                                                )
                                            }
                                        </View>
                                    </View>


                                    <HMListItemTitle
                                        backgroundColorTitle={Colors.colorSecondPrimary}

                                        // title={"معرفی دوستان"}
                                        styleRoot={{marginTop: moderateScale(4)}}
                                        text={i18n.t('constant.MessageNumber')}
                                        title={item.TrackingCode}

                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={'md-clipboard'}
                                        NoShowIconOnpress
                                        onPress={() => {
                                            //   this.onShare()
                                        }}
                                    />
                                    <HMListItemTitle
                                        backgroundColorTitle={Colors.colorSecondPrimary}

                                        // title={"معرفی دوستان"}
                                        styleRoot={{marginTop: moderateScale(4)}}
                                        text={i18n.t('constant.Date')}
                                        title={item.DateTimeJalali}

                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={'md-clipboard'}
                                        NoShowIconOnpress
                                        onPress={() => {
                                            //   this.onShare()
                                        }}
                                    />
                                    <HMListItemTitle
                                        backgroundColorTitle={Colors.colorSecondPrimary}

                                        // title={"معرفی دوستان"}
                                        styleRoot={{marginTop: moderateScale(4)}}
                                        text={i18n.t('constant.title')}
                                        title={item.SubjectName}

                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={'md-clipboard'}
                                        NoShowIconOnpress
                                        onPress={() => {
                                            //   this.onShare()
                                        }}
                                    />

                                    <HMListItemTitle
                                        backgroundColorTitle={Colors.colorSecondPrimary}

                                        // title={"معرفی دوستان"}
                                        styleRoot={{marginTop: moderateScale(4)}}
                                        text={i18n.t('constant.Citizen')}
                                        title={item.Name}

                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={'md-clipboard'}
                                        NoShowIconOnpress
                                        onPress={() => {
                                            //   this.onShare()
                                        }}
                                    />
                                    <HMListItemTitle
                                        backgroundColorTitle={Colors.colorSecondPrimary}

                                        // title={"معرفی دوستان"}
                                        styleRoot={{marginTop: moderateScale(4)}}
                                        text={i18n.t('constant.address')}
                                        title={item.Address}

                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={'md-clipboard'}
                                        NoShowIconOnpress
                                        onPress={() => {
                                            //   this.onShare()
                                        }}
                                    />
                                    <HMListItemTitle
                                        backgroundColorTitle={Colors.colorSecondPrimary}

                                        // title={"معرفی دوستان"}
                                        styleRoot={{marginTop: moderateScale(4)}}
                                        text={i18n.t('constant.phoneNumber')}
                                        title={item.CallerID}
                                        file={'link'}
                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={'md-clipboard'}
                                        NoShowIconOnpress
                                        onPressChild={() => {
                                            Tools.GoLink(item.CallerID, 'phone');
                                            //   this.onShare()
                                        }}
                                    />
                                    {/*   <HMListItemTitle
                                            backgroundColorTitle={Colors.colorSecondPrimary}

                                            // title={"معرفی دوستان"}
                                            file={'link'}
                                            styleRoot={{marginTop: moderateScale(4)}}
                                            text={i18n.t('constant.phone')}
                                            title={item.tel}

                                            //   image={require("../../assets/img/add-friend.png")}
                                            image={"md-clipboard"}
                                            NoShowIconOnpress
                                            onPressChild={() => {
                                                Tools.GoLink(item.tel, "phone")
                                                //   this.onShare()
                                            }}
                                        />*/}
                                    <HMListItemTitle
                                        backgroundColorTitle={Colors.colorSecondPrimary}

                                        // title={"معرفی دوستان"}
                                        styleRoot={{marginTop: moderateScale(4)}}
                                        text={i18n.t('constant.Description')}
                                        title={item.Description}

                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={'md-clipboard'}
                                        NoShowIconOnpress
                                        onPress={() => {
                                            //   this.onShare()
                                        }}
                                    />
                                    <HMListItemTitle
                                        backgroundColorTitle={Colors.colorSecondPrimary}

                                        // title={"معرفی دوستان"}
                                        styleRoot={{marginTop: moderateScale(4)}}
                                        text={i18n.t('constant.Status')}
                                        title={item.Status}

                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={'md-clipboard'}
                                        NoShowIconOnpress
                                        onPress={() => {
                                            //   this.onShare()
                                        }}
                                    />
                                    {/*
                                    <HMListItemTitle
                                        backgroundColorTitle={Colors.colorSecondPrimary}
                                        text={i18n.t('constant.Image')}
                                        title={this.state.listImage.length > 0 ? i18n.t('constant.View') : null}
                                        file={"aaaa"}
                                        path={this.state.listImage.length > 0 ? this.state.listImage : null}
                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={"md-image"}
                                        styleRoot={{marginTop: moderateScale(4)}}

                                        NoShowIconOnpress
                                        onPress={() => {
                                            //   this.onShare()
                                        }}
                                        onPressChild={
                                            () => this.setState({
                                                visibleModal: "selectSlider",
                                                // pathVideo: checkVideo
                                                sliderList: this.state.listImage
                                            })
                                        }
                                    />
                                    <HMListItemTitle
                                        backgroundColorTitle={Colors.colorSecondPrimary}
                                        text={i18n.t('constant.Video')}
                                        title={this.state.listVideo.length > 0 ? i18n.t('constant.View') : null}
                                        file={"video"}
                                        //  path={checkImage ? checkImage : null}
                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={"md-image"}
                                        styleRoot={{marginTop: moderateScale(4)}}
                                        onPressChild={
                                            () => this.setState({
                                                visibleModal: "selectVideo",
                                                //  pathVideo: checkVideo,
                                                sliderList: this.state.listVideo,
                                                slider1ActiveSlide: 0

                                            })
                                        }
                                        NoShowIconOnpress
                                        onPress={() => {
                                            //   this.onShare()
                                        }}
                                    />
                                    <HMListItemTitle
                                        backgroundColorTitle={Colors.colorSecondPrimary}
                                        text={i18n.t('constant.Voice')}
                                        title={this.state.listVoice.length > 0 ? i18n.t('constant.View') : null}
                                        file={"video"}
                                        path={this.state.listVoice.length > 0 ? this.state.listVoice : null}
                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={"md-image"}
                                        styleRoot={{marginTop: moderateScale(4)}}
                                        onPressChild={
                                            () => this.setState({
                                                visibleModal: "selectaudio",
                                                //  pathVideo: checkAudio,
                                                sliderList: this.state.listVoice,

                                                slider1ActiveSlide: 0
                                                // visibleModal: "selectaudio",
                                                // pathAudio: checkAudio
                                            }, () => {
                                            })
                                        }
                                        NoShowIconOnpress
                                        onPress={() => {
                                            //   this.onShare()
                                        }}
                                    />
                                    <HMListItemTitle
                                        backgroundColorTitle={Colors.colorSecondPrimary}
                                        text={i18n.t('constant.Files')}
                                        title={this.state.listOthers.length > 0 ? i18n.t('constant.View') : null}
                                        file={"others"}
                                        path={this.state.listOthers.length > 0 ? this.state.listOthers : null}
                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={"md-image"}
                                        styleRoot={{marginTop: moderateScale(4)}}
                                        onPressChild={
                                            () => this.setState({
                                                visibleModal: "selectSlider",
                                                //  pathVideo: checkAudio,
                                                sliderList: this.state.listOthers,

                                                slider1ActiveSlide: 0
                                                // visibleModal: "selectaudio",
                                                // pathAudio: checkAudio
                                            })
                                        }
                                        NoShowIconOnpress
                                        onPress={() => {
                                            //   this.onShare()
                                        }}
                                    />*/}
                                    {/*       <View
                                        style={{
                                            flex: 1,
                                        }}>
                                        <View
                                            style={{

                                            flexDirection: 'row',
                                            ///  backgroundColor:'#a8ee7c',
                                            marginHorizontal: moderateScale(5),
                                            marginTop: moderateScale(8),
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            alignSelf: 'center',
                                        }}>
                                            <HMTextView


                                                type={"bold"}

                                                style={{
                                                    fontSize: moderateScale(12),
                                                    color: Colors.blackLight,
                                                    textAlign: 'center',
                                                    // marginTop: moderateScale(10)
                                                }}
                                                text={i18n.t('constant.message')}
                                                //   text={"98/03/21"}
                                            />


                                        </View>
                                        <FlatList
                                            // ItemSeparatorComponent={
                                            //     <View style={{
                                            //         width: '100%',
                                            //         height: moderateScale(1),
                                            //         backgroundColor: '#4f4f4f'
                                            //     }}/>
                                            // }
                                            data={lastWork === null || !lastWork ? [] : lastWork}
                                            renderItem={({item, index}) => {
                                                let files = item.Files
                                                let checkAudio = audio || audio === null ? audio : (files && files.length > 0 && (files.find(k => k.type === 'audio/aac')) && (files.find(k => k.type === 'audio/aac')).file)
                                                let checkImage = image || image === null ? image : (files && files.length > 0 && (files.find(k => k.type === 'image/jpeg')) && (files.find(k => k.type === 'image/jpeg')).file)
                                                let checkVideo = video || video === null ? video : (files && files.length > 0 && (files.find(k => k.type === 'video/mp4')) && (files.find(k => k.type === 'video/mp4')).file)

                                                let listVoice = [];
                                                let listImage = [];
                                                let listVideo = [];
                                                let listOthers = [];
                                                if (files)
                                                    for (let i = 0; i < files.length; i++) {
                                                        let f = String(files[i].type);

                                                        if (f.search('audio/') >= 0)
                                                            listVoice.push(files[i])

                                                        else if (f.search('image/') >= 0)
                                                            listImage.push(files[i])

                                                        else if (f.search('video/') >= 0)
                                                            listVideo.push(files[i])
                                                        else {
                                                            listOthers.push(files[i])
                                                        }

                                                    }

                                                return (
                                                    <View
                                                        style={{
                                                            // width: "100%",
                                                            flex: 1,
                                                            marginHorizontal: moderateScale(10),
                                                            //  marginVertical: moderateScale(2),
                                                            // padding: moderateScale(6)
                                                        }}>
                                                        <Card>
                                                            <CardItem cardBody style={{
                                                                paddingLeft: 0,
                                                                paddingRight: 0,
                                                                paddingTop: 0,
                                                                paddingBottom: 0,
                                                            }}>
                                                                <View
                                                                    style={{
                                                                        //paddingVertical: moderateScale(10),
                                                                        width: '100%',

                                                                        padding: moderateScale(6)
                                                                    }}
                                                                >


                                                                    <View style={{
                                                                        flexDirection: 'row',
                                                                        alignSelf: "center",
                                                                        width: '100%'
                                                                    }}>
                                                                        <View style={{flex: .65}}>
                                                                            <HMTextView

                                                                                type={"bold"}
                                                                                //
                                                                                style={{
                                                                                    fontSize: moderateScale(12),
                                                                                    color: Colors.colorDark,

                                                                                    // marginTop: moderateScale(10)
                                                                                }}
                                                                                text={item.User}
                                                                                //   text={"98/03/21"}
                                                                            />

                                                                        </View>

                                                                        <View style={{
                                                                            flex: .35,
                                                                            flexDirection: 'row',
                                                                            justifyContent: 'flex-end'
                                                                        }}>
                                                                            <HMTextView

                                                                                //type={"bold"}

                                                                                style={{
                                                                                    fontSize: moderateScale(12),
                                                                                    color: Colors.colorDarkText,


                                                                                    // marginTop: moderateScale(10)
                                                                                }}
                                                                                text={item.AnswerTime}
                                                                            />
                                                                        </View>


                                                                    </View>
                                                                    <View style={{
                                                                        width: '100%',
                                                                        height: moderateScale(1),
                                                                        backgroundColor: '#eee',
                                                                        alignSelf: 'center'
                                                                    }}/>
                                                                    <View
                                                                    style={{
                                                                    flexDirection: 'row',
                                                                    flex: 1,
                                                                    marginVertical: moderateScale(6),
                                                                    marginHorizontal: moderateScale(3)
                                                                    }}>
                                                                    <HMTextView

                                                                    type={"bold"}

                                                                    style={{
                                                                    fontSize: moderateScale(12),
                                                                    color: item.color ? item.color : Colors.colorDarkText,

                                                                    // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={item.status}
                                                                    />


                                                                    </View>
                                                                    <View
                                                                        style={{
                                                                            flexDirection: 'row',
                                                                            flex: 1,
                                                                            marginBottom: moderateScale(6),
                                                                            marginHorizontal: moderateScale(3)
                                                                        }}>

                                                                        <HMTextView

                                                                            // type={"bold"}
                                                                            //
                                                                            style={{
                                                                                fontSize: moderateScale(12),
                                                                                color: Colors.colorDark,

                                                                                // marginTop: moderateScale(10)
                                                                            }}
                                                                            text={item.AnswerComment ? item.AnswerComment : ""}
                                                                            //   text={"98/03/21"}
                                                                        />
                                                                    </View>
                                                                       <View style={{
                                                            width: '100%',
                                                            height: moderateScale(1),
                                                            backgroundColor: '#4f4f4f'
                                                        }}/>
                                                                    <View style={{flex: 1, flexDirection: 'row',}}>
                                                                        <View style={{
                                                                            flex: .5,
                                                                            flexDirection: 'row',
                                                                        }}>


                                                                            {

                                                                            <Lightbox
                                                                            renderContent={() => (
                                                                            <View style={{
                                                                            width: typeExport.WIDTH,
                                                                            height: typeExport.HEIGHT
                                                                            }}>
                                                                            {
                                                                            <Image
                                                                            style={{
                                                                            flex: 1,
                                                                            resizeMode: 'contain'
                                                                            }}
                                                                            source={{uri: checkImage}}
                                                                            />

                                                                            }

                                                                            </View>
                                                                            )}>
                                                                            <HMIcon name={"md-image"} style={{
                                                                            alignSelf: 'center',
                                                                            // width: moderateScale(14),
                                                                            color: checkImage ? Colors.colorPrimaryDark : Colors.gray,
                                                                            fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                                            textAlign: 'center'
                                                                            }}/>

                                                                            </Lightbox>


                                                                            }
                                                                            {


                                                                                <TouchableOpacity
                                                                                    onPress={
                                                                                        () => listImage.length > 0 ? this.setState({
                                                                                                visibleModal: "selectVideo",
                                                                                                // pathVideo: checkVideo,
                                                                                                sliderList: listVideo,

                                                                                                slider1ActiveSlide: 0
                                                                                            })

                                                                                            :
                                                                                            null
                                                                                    }

                                                                                    style={{
                                                                                        // flex: .33,
                                                                                        flexDirection: 'row',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        //   marginHorizontal: moderateScale(5)
                                                                                    }}>
                                                                                    <HMIcon name={"md-videocam"}
                                                                                          style={{
                                                                                              alignSelf: 'center',
                                                                                              // width: moderateScale(14),
                                                                                              color: checkVideo ? Colors.colorPrimaryDark : Colors.gray,
                                                                                              fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                                                              textAlign: 'center'
                                                                                          }}/>
                                                                                </TouchableOpacity>

                                                                            }

                                                                            {


                                                                                <TouchableOpacity
                                                                                    onPress={
                                                                                        () => listImage.length > 0 ? this.setState({
                                                                                                visibleModal: "selectSlider",
                                                                                                sliderList: listImage,
                                                                                                slider1ActiveSlide: 0
                                                                                            })
                                                                                            :
                                                                                            null

                                                                                    }

                                                                                    style={{
                                                                                        // flex: .33,
                                                                                        flexDirection: 'row',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        //   marginHorizontal: moderateScale(5)
                                                                                    }}>
                                                                                    <HMIcon name={"images"}
                                                                                          style={{
                                                                                              alignSelf: 'center',
                                                                                              // width: moderateScale(14),
                                                                                              color: listImage.length > 0 ? Colors.colorPrimaryDark : Colors.gray,
                                                                                              fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                                                              textAlign: 'center'
                                                                                          }}/>
                                                                                </TouchableOpacity>

                                                                            }
                                                                            {


                                                                                <TouchableOpacity

                                                                                    onPress={
                                                                                        () => listVoice.length > 0 ? this.setState({
                                                                                                visibleModal: "selectVideo",
                                                                                                //   pathVideo: checkAudio,
                                                                                                sliderList: listVoice,

                                                                                                slider1ActiveSlide: 0,
                                                                                                // visibleModal: "selectaudio",
                                                                                                // pathAudio: checkAudio,
                                                                                            })
                                                                                            : null
                                                                                    }
                                                                                    style={{
                                                                                        // flex: .33,
                                                                                        flexDirection: 'row',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        //  marginHorizontal: moderateScale(5)
                                                                                    }}>
                                                                                    <HMIcon name={"md-mic"} style={{
                                                                                        alignSelf: 'center',
                                                                                        // width: moderateScale(14),
                                                                                        color: listVoice.length > 0 ? Colors.colorPrimaryDark : Colors.gray,
                                                                                        fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                                                        textAlign: 'center'
                                                                                    }}/>
                                                                                </TouchableOpacity>

                                                                            }
                                                                            {


                                                                                <TouchableOpacity

                                                                                    onPress={
                                                                                        () => listOthers.length > 0 ? this.setState({
                                                                                                visibleModal: "selectListOthers",
                                                                                                sliderList: listOthers,
                                                                                                slider1ActiveSlide: 0,
                                                                                                // visibleModal: "selectaudio",
                                                                                                // pathAudio: checkAudio,
                                                                                            })
                                                                                            : null
                                                                                    }
                                                                                    style={{
                                                                                        // flex: .33,
                                                                                        flexDirection: 'row',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        //  marginHorizontal: moderateScale(5)
                                                                                    }}>
                                                                                    <HMIcon name={"ios-attach"}
                                                                                          style={{
                                                                                              alignSelf: 'center',
                                                                                              // width: moderateScale(14),
                                                                                              color: listOthers.length > 0 ? Colors.colorPrimaryDark : Colors.gray,
                                                                                              fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                                                              textAlign: 'center'
                                                                                          }}/>
                                                                                </TouchableOpacity>

                                                                            }

                                                                        </View>
                                                                        {

                                                                            <View style={{
                                                                                flex: .5,
                                                                                flexDirection: 'row',
                                                                                justifyContent: 'flex-end'
                                                                            }}>
                                                                                <HMIcon name={"ios-text"} style={{
                                                                                alignSelf: 'center',
                                                                                // width: moderateScale(14),
                                                                                color: Colors.colorDark,
                                                                                marginHorizontal: moderateScale(5),
                                                                                fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                                                textAlign: 'center'
                                                                                }}/>
                                                                                <HMTextView

                                                                                //type={"bold"}

                                                                                style={{
                                                                                fontSize: moderateScale(11),
                                                                                color: Colors.gray,

                                                                                // marginTop: moderateScale(10)
                                                                                }}
                                                                                text={item.lastWork && item.lastWork.length > 0 ? item.lastWork.length : 0}
                                                                                //   text={"98/03/21"}
                                                                                />
                                                                            </View>
                                                                        }

                                                                    </View>


                                                                </View>
                                                            </CardItem>
                                                        </Card>
                                                    </View>
                                                );
                                            }

                                            }
                                        />


                                    </View>*/}
                                </View>
                            </ScrollView>


                            <Popup
                                isVisible={this.state.isVisible}
                                onCancelPressed={() => this.setState({isVisible: false})}
                                onAppPressed={() => this.setState({isVisible: false})}
                                onBackButtonPressed={() => this.setState({isVisible: false})}
                                options={{
                                    latitude: latitude,
                                    longitude: longitude,
                                    // title: 'The White House',
                                    dialogTitle: i18n.t('constant.Routing'),
                                    dialogMessage: i18n.t('constant.SelectingDestination'),
                                    cancelText: i18n.t('constant.Back'),
                                }}
                            />


                            {
                                this.renderModalMenu()
                            }


                            <HMModal
                                isVisible={this.state.visibleModal === 'selectListOthers'}
                                backdropColor={Colors.gray}
                                backdropOpacity={0.8}
                                animationIn="zoomInDown"
                                animationOut="zoomOutUp"
                                animationInTiming={600}
                                animationOutTiming={600}
                                backdropTransitionInTiming={600}
                                backdropTransitionOutTiming={600}
                                //style={{height: '60%'}}
                                onBackdropPress={() => this.hiddenModal()}
                                onBackButtonPress={() => this.hiddenModal()}
                                style={{zIndex: 3}}

                            >

                                <View style={{
                                    //  height: "90%",
                                    padding: moderateScale(6),
                                    backgroundColor: Colors.white,
                                }}>
                                    <View style={{width: '100%', alignItems: 'center'}}>
                                        <HMTextView

                                            //type={"bold"}
                                            //
                                            style={{
                                                fontSize: moderateScale(11),
                                                color: Colors.colorPrimary,


                                                // marginTop: moderateScale(10)
                                            }}
                                            // text={item.status}
                                            text={i18n.t('constant.Files')}
                                            //   text={"98/03/21"}
                                        />
                                    </View>
                                    <FlatList

                                        data={this.state.sliderList}
                                        renderItem={({item, index}) =>
                                            <View
                                                style={{
                                                    // width: "100%",
                                                    flex: 1,
                                                    marginHorizontal: moderateScale(10),
                                                    //  marginVertical: moderateScale(2),
                                                    // padding: moderateScale(6)
                                                }}>
                                                {/*    <Card>
                                                    <CardItem cardBody style={{
                                                        paddingLeft: 0,
                                                        paddingRight: 0,
                                                        paddingTop: 0,
                                                        paddingBottom: 0,
                                                    }}>*/}
                                                <TouchableOpacity
                                                    onPress={() => {
                                                        Tools.GoLink(item.file);
                                                    }}
                                                    style={{
                                                        //paddingVertical: moderateScale(10),
                                                        //  width: '100%',
                                                        alignItems: 'center',
                                                        flexDirection: 'row',
                                                        flex: 1,
                                                        padding: moderateScale(6),
                                                    }}
                                                >

                                                    <View


                                                        style={{
                                                            flex: .2,
                                                            //   width: moderateScale(32),
                                                            // height: moderateScale(32),
                                                            // backgroundColor: '#ee005b',
                                                            //  position: 'absolute',
                                                            //   borderRadius: moderateScale(16),
                                                            //margin: moderateScale(4),
                                                            //   top: 0,
                                                            //   left: 0,

                                                            //  justifyContent: 'center',

                                                        }}>
                                                        <HMIcon name={'ios-attach'} style={{
                                                            textAlign: 'center',
                                                            //alignSelf: 'flex-end',
                                                            color: Colors.gray,
                                                            // width: moderateScale(32),
                                                            // height: moderateScale(32),
                                                            fontSize: moderateScale(22),
                                                        }}/>


                                                    </View>

                                                    <View style={{flex: .8}}>
                                                        <HMTextView

                                                            //type={"bold"}
                                                            //
                                                            style={{
                                                                fontSize: moderateScale(11),
                                                                color: Colors.colorDark,

                                                                // marginTop: moderateScale(10)
                                                            }}
                                                            // text={item.status}
                                                            text={item.file}
                                                            //   text={"98/03/21"}
                                                        />
                                                    </View>

                                                </TouchableOpacity>
                                                {/*           </CardItem>
                                                </Card>*/}
                                            </View>
                                        }
                                    />


                                </View>
                            </HMModal>

                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize
                                        onPress={() => this.getData()}
                                    />
                                    :
                                    null
                            }
                            {
                                this.props.isLoading || this.state.isLoading ?
                                    // this.props.isLoading ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }


                            {
                                this.state.visibleModal === 'selectSlider' || this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectaudio' ?
                                    <View
                                        style={{
                                            position: 'absolute',
                                            flex: 1,
                                            alignContent: 'center',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginTop: Platform.OS === 'ios' ? moderateScale(15) : 0,
                                            top: 0,
                                            bottom: 0,
                                            right: 0,
                                            left: 0,
                                            backgroundColor: 'rgba(0,0,0,0.7)',
                                            zIndex: 1,
                                        }}>
                                        <View style={{
                                            height: '100%',
                                            width: '100%',
                                            // padding: moderateScale(6),
                                            backgroundColor: Colors.black,
                                            position: 'relative',
                                        }}>
                                            {
                                                <View
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        right: 0,
                                                        left: 0,
                                                        bottom: 0,
                                                    }}

                                                >

                                                    <HMSwiper
                                                        list={this.state.sliderList}
                                                        renderItem={() =>
                                                            this.state.sliderList.map((item, index) => {
                                                                let {title, description, latitude, longitude, address, code, status, files, createdtime, comment} = this.props.route.params.item;

                                                                return <View
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '100%',
                                                                    }}
                                                                >

                                                                    {
                                                                        this.state.visibleModal === 'selectSlider' ?
                                                                            <Image
                                                                                resizeMode={'contain'}
                                                                                style={{
                                                                                    flex: 1,
                                                                                }}
                                                                                // source={{uri: 'http://v1.qzone.cc/avatar/201407/07/00/24/53b9782c444ca987.jpg!200x200.jpg'}}
                                                                                source={{uri: item.file}}
                                                                            />
                                                                            :
                                                                            null
                                                                    }

                                                                    {
                                                                        this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectaudio' ?
                                                                            <HMVideo
                                                                                title={title}
                                                                                navigation={this.props.navigation}
                                                                                item={item} index={item.index}
                                                                                indexSelect={this.state.slider1ActiveSlide}
                                                                                //url={"http://techslides.com/demos/sample-videos/small.mp4"}
                                                                            />

                                                                            :
                                                                            null
                                                                    }


                                                                </View>;

                                                            })
                                                        }
                                                    />
                                                    {/*   <Carousel page

                                                              ref={c => this._slider1Ref = c}
                                                              data={this.state.sliderList}
                                                        //    data={[1, 2, 3, 4, 5].}
                                                        //    data={this.state.entries}
                                                              renderItem={(item, index) => this.renderCarousel(item, index)


                                                              }
                                                        // inactiveSlideScale={.99}
                                                        // sliderWidth={sliderWidth}
                                                        // itemWidth={itemWidth}

                                                              inactiveSlideScale={1}
                                                        // sliderWidth={sliderWidth}
                                                        // itemWidth={itemWidth}

                                                              sliderWidth={Dimensions.get('window').width}
                                                              itemWidth={Dimensions.get('window').width}
                                                              hasParallaxImages={true}
                                                              firstItem={0}

                                                              inactiveSlideOpacity={0.7}
                                                        // inactiveSlideShift={20}
                                                              containerCustomStyle={styles_Carousel.slider}
                                                              contentContainerCustomStyle={styles_Carousel.sliderContentContainer}
                                                        // loop={true}
                                                        //loopClonesPerSide={1}
                                                        //    autoplay={true}
                                                        //   autoplayDelay={1000}
                                                        //   autoplayInterval={6000}
                                                              onSnapToItem={(index, item) => {
                                                                  //  alert("jvhcjk")
                                                                  //   this.pauseVideo(slider1ActiveSlide)
                                                                  // this[`video${slider1ActiveSlide}`].pause()

                                                                  // if( this.state.visibleModal === 'selectVideo' )
                                                                  // for (let i = 0; i <4 ; i++) {
                                                                  // }
                                                                  // this[`video0`].pause()
                                                                  // this[`video1`].pause()
                                                                  // this[`video2`].pause()
                                                                  // this[`video3`].pause()

                                                                  let p = "paused" + slider1ActiveSlide
                                                                  //  console.log(this.state[p])
                                                                  this.setState({
                                                                      [p]: true,
                                                                      slider1ActiveSlide: index
                                                                  }, () => {
                                                                      //   console.log(this.state[p], this.state["paused" + slider1ActiveSlide])
                                                                  })
                                                              }
                                                              }
                                                              removeClippedSubviews={false}
                                                    />*/}
                                                </View>
                                            }

                                        </View>
                                        <TouchableOpacity
                                            onPress={() => {
                                                this.hiddenModal();
                                            }}

                                            style={{
                                                width: moderateScale(32),
                                                height: moderateScale(32),
                                                // backgroundColor: '#ee005b',
                                                position: 'absolute',
                                                borderRadius: moderateScale(16),
                                                margin: moderateScale(4),
                                                top: 0,
                                                left: 0,
                                                alignItems: 'center',
                                                justifyContent: 'center',

                                            }}>
                                            <HMIcon name={'ios-close-circle-outline'} style={{
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: Colors.white,
                                                // width: moderateScale(32),
                                                // height: moderateScale(32),
                                                fontSize: moderateScale(22),
                                            }}/>
                                        </TouchableOpacity>
                                    </View>
                                    :
                                    null
                            }

                        </View>


                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }


    renderCarousel(item, index) {
        let {title, description, latitude, longitude, address, code, status, files, createdtime, comment} = this.props.route.params.item;

        return <View
            style={{
                width: '100%',
                height: '100%',
            }}
        >

            {
                this.state.visibleModal === 'selectSlider' ?
                    <Image
                        resizeMode={'contain'}
                        style={{
                            flex: 1,
                        }}
                        // source={{uri: 'http://v1.qzone.cc/avatar/201407/07/00/24/53b9782c444ca987.jpg!200x200.jpg'}}
                        source={{uri: item.item.file}}
                    />
                    :
                    null
            }
            {/*{*/}
            {/*this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectaudio'?*/}
            {/*<Video*/}
            {/*style={{*/}
            {/*flex: 1,*/}
            {/*resizeMode: 'contain'*/}
            {/*}}*/}
            {/*autoPlay={false}*/}
            {/*// paused={this.state["paused" + item.index]}*/}
            {/*// ref={(ref) => this.video = {...this.video, [`REF-FLATLIST${index}`]: ref}}*/}
            {/*ref={(ref) => {*/}
            {/*//  ...this.video$, [`REF-FLATLIST${item.key}`]: ref*/}
            {/*// this[`video${index}`]=ref*/}
            {/*this["video" + item.index] = ref*/}
            {/*}}*/}

            {/*// autoPlay*/}
            {/*//  url={checkVideo ? files.find(k => k.type === 'video/mp4').file : null}*/}
            {/*//   url={this.state.pathVideo ? this.state.pathVideo : null}*/}
            {/*// url={"http://techslides.com/demos/sample-videos/small.mp4"}*/}
            {/*//   url={"http://techslides.com/demos/sample-videos/small.mp4"}*/}
            {/*url={item.item.file}*/}
            {/*title={title}*/}
            {/*// logo={logo}*/}
            {/*//    placeholder={placeholder}*/}
            {/*//  onMorePress={() => this.onMorePress()}*/}
            {/*onFullScreen={status => {*/}
            {/*// this["video" + item.index].pause()*/}
            {/*this.onFullScreen(status)*/}
            {/*}*/}
            {/*}*/}
            {/*//   fullScreenOnly*/}
            {/*theme={theme}*/}
            {/*/>*/}

            {/*:*/}
            {/*null*/}
            {/*}*/}
            {
                this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectaudio' ?
                    <HMVideo
                        title={title}
                        navigation={this.props.navigation} item={item} index={item.index}
                        indexSelect={this.state.slider1ActiveSlide}
                        //url={"http://techslides.com/demos/sample-videos/small.mp4"}
                    />

                    :
                    null
            }
            {/*{*/}
            {/*this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectaudio' ?*/}
            {/*<Video*/}
            {/*style={{flex: 1, resizeMode: 'contain'}}*/}
            {/*autoPlay={false}*/}
            {/*ref={(ref) => {*/}
            {/*this.video = ref*/}
            {/*}}*/}
            {/*// autoPlay*/}
            {/*//  url={checkVideo ? files.find(k => k.type === 'video/mp4').file : null}*/}
            {/*url={item.item.file}*/}
            {/*title={title}*/}
            {/*// logo={logo}*/}
            {/*//  placeholder={placeholder}*/}
            {/*//  onMorePress={() => this.onMorePress()}*/}
            {/*onFullScreen={status => this.onFullScreen(status)}*/}
            {/*//   fullScreenOnly*/}
            {/*theme={theme}*/}
            {/*/>*/}
            {/*:*/}
            {/*null*/}
            {/*}*/}

        </View>;
    }

    /*    renderTabBar(props) {
            return (<TabBar
                    style={{
                        backgroundColor: '#FFFFFF',
                        elevation: 0,
                        borderColor: '#000000',
                        borderBottomWidth: 1,
                        height: 50
                    }}
                    labelStyle={{color: 'black', fontSize: 18, fontWeight: 'bold'}}
                    {...props}
                    indicatorStyle={{backgroundColor: '#e65970', height: 2.5}}
                />
            );
        }*/

    async changeState() {

        if (container.props.route.params.index >= 0) {

            if (container.props.route.params.offline) {

                let date = moment().format('jYYYY/jM/jD HH:mm');
                let arr =
                    container.state.ListTask.map((val, key) => {
                        if (key === container.props.route.params.index) {
                            switch (container.state.idMenu) {
                                case 1:
                                    val.ReachTimeState = 1;
                                    val.ReachTime = date;
                                    break;
                                case 2:
                                    val.FireTimeState = 1;
                                    val.FireTime = date;
                                    break;
                                case 3:
                                    val.ReturnTimeState = 1;
                                    val.ReturnTime = date;
                                    break;
                                case 4:
                                    val.CountAnswers = val.CountAnswers + 1;
                                    break;
                                case 5:
                                    val.StateMelkDetail = true;
                                    break;

                                case 6:
                                    val.CountDamage = val.CountDamage + 1;

                                    break;
                                case 7:
                                    val.StateInformation = true;
                                    break;
                                case 8:
                                    val.CountTools = val.CountTools + 1;
                                    break;
                                case 10:
                                    val.StateConfirmOperation = true;
                                    break;
                                default:
                                    break;

                            }

                            return val;
                        }
                        return val;
                    });
                container.setState({
                        ListTask: arr,
                    },
                    () => {
                    },
                );

                await AsyngStorageClass.setAsyng(global.IdCity + 'ListMessageHistoryOperatorFireScreen', arr);

                // container.saveOfflineTask(true)
            }
            else {
                await store.dispatch(serviceActionChangeState(container.props.route.params.index, container.state.idMenu));

            }
        }
    }

    getNameBuilding() {
        let idx = container.state.TypeBuildingList.findIndex(obj => obj.value == container.state.typeBuilding);
        if (idx !== -1) {
            let r = container.state.TypeBuildingList[idx];
            return {label: r.label, value: r.value, index: idx};

        }
        else {
            return {label: i18n.t('constant.SelectItem'), value: idx, index: idx};
        }

    }

    renderChildModalMenu(options) {

        switch (this.state.typeMenu) {

            case 4:
                return <View>
                    <EmptyView empty={this.state.FileList && this.state.FileList.length === 0}/>

                    <FlatList
                        data={this.state.FileList}
                        renderItem={({item, index}) => {
                            let files = item.Files;
                            let checkAudio = (files && files.length > 0 && (files.find(k => k.type === 'audio/aac')) && (files.find(k => k.type === 'audio/aac')).file);
                            let checkImage = (files && files.length > 0 && (files.find(k => k.type === 'image/jpeg')) && (files.find(k => k.type === 'image/jpeg')).file);
                            let checkVideo = (files && files.length > 0 && (files.find(k => k.type === 'video/mp4')) && (files.find(k => k.type === 'video/mp4')).file);

                            let listVoice = [];
                            let listImage = [];
                            let listVideo = [];
                            let listOthers = [];
                            if (files) {
                                for (let i = 0; i < files.length; i++) {
                                    let f = String(files[i].type);

                                    if (f.search('audio/') >= 0) {
                                        listVoice.push(files[i]);
                                    } else if (f.search('image/') >= 0) {
                                        listImage.push(files[i]);
                                    } else if (f.search('video/') >= 0) {
                                        listVideo.push(files[i]);
                                    } else {
                                        listOthers.push(files[i]);
                                    }

                                }
                            }

                            return (
                                <View
                                    style={{
                                        // width: "100%",
                                        flex: 1,
                                        marginHorizontal: moderateScale(10),
                                        marginVertical: moderateScale(4),

                                        borderRadius: moderateScale(6),
                                        borderColor: '#d0d8df',
                                        borderWidth: moderateScale(1),
                                        overflow: 'hidden',
                                        //  marginVertical: moderateScale(2),
                                        // padding: moderateScale(6)
                                    }}>

                                    <View
                                        style={{
                                            //paddingVertical: moderateScale(10),
                                            width: '100%',

                                            padding: moderateScale(6),
                                        }}
                                    >


                                        <View style={{
                                            flexDirection: 'row',
                                            alignSelf: 'center',
                                            width: '100%',
                                            paddingVertical: moderateScale(4),
                                        }}>
                                            <View style={{flex: .65}}>
                                                <HMTextView

                                                    type={'bold'}
                                                    //
                                                    style={{
                                                        fontSize: moderateScale(12),
                                                        color: Colors.colorDark,

                                                        // marginTop: moderateScale(10)
                                                    }}
                                                    text={item.User}
                                                    //   text={"98/03/21"}
                                                />

                                            </View>

                                            <View style={{
                                                flex: .35,
                                                flexDirection: 'row',
                                                justifyContent: 'flex-end',
                                            }}>
                                                <HMTextView

                                                    //type={"bold"}

                                                    style={{
                                                        fontSize: moderateScale(12),
                                                        color: Colors.colorDarkText,


                                                        // marginTop: moderateScale(10)
                                                    }}
                                                    text={item.AnswerTime}
                                                />
                                            </View>


                                        </View>
                                        <View style={{
                                            width: '100%',
                                            height: moderateScale(1),
                                            backgroundColor: '#eee',
                                            alignSelf: 'center',
                                        }}/>

                                        <View
                                            style={{
                                                flexDirection: 'row',
                                                width: "100%",
                                                marginBottom: moderateScale(6),
                                                marginHorizontal: moderateScale(3),
                                            }}>

                                            <HMTextView

                                                // type={"bold"}
                                                //
                                                style={{
                                                    fontSize: moderateScale(12),
                                                    color: Colors.colorDark,

                                                    // marginTop: moderateScale(10)
                                                }}
                                                text={item.AnswerComment ? item.AnswerComment : ''}
                                                //   text={"98/03/21"}
                                            />
                                        </View>
                                        {/*   <View style={{
                                                            width: '100%',
                                                            height: moderateScale(1),
                                                            backgroundColor: '#4f4f4f'
                                                        }}/>*/}


                                        <View
                                            style={{
                                                //position:'absolute',
                                                flexDirection: 'row',
                                                flexWrap: 'wrap',
                                                flex: 1,

                                                flexGrow: 1,
                                                alignItems: 'center',
                                                //  alignItems: 'center', justifyContent: 'center',
                                                //  backgroundColor: _main ? "#eee" : Colors.transparent,
                                              //  backgroundColor: "#876a79",
                                            }}>
                                            {
                                                (listImage).map((itemImage, key) => {
                                                    console.log(itemImage);
                                                    return <TouchableOpacity
                                                        key={key + '_' + index}
                                                        style={{
                                                            width: moderateScale(80),
                                                            height: moderateScale(80),
                                                            margin: moderateScale(4),
                                                        }}
                                                        onPress={() => {

                                                            this.setState({
                                                                visibleModal: 'selectSlider',
                                                                visibleModalMenu: '',

                                                                sliderList: [itemImage],
                                                                slider1ActiveSlide: 0,
                                                            });

                                                        }}
                                                    >
                                                        <HMImageView
                                                            resizeMode={'cover'}
                                                            uriComplete={itemImage.file}
                                                            _backgroundColorLoading={Colors.black}
                                                            styleImage={{
                                                                //  resizeMode: 'cover',
                                                                width: '100%',
                                                                height: '100%',
                                                                //   backgroundColor: "#ee7e0c",
                                                                //  borderTopRightRadius:moderateScale(8),
                                                                //  borderTopEndRadius: moderateScale(12),
                                                                //  borderTopStartRadius: moderateScale(8),
                                                            }}
                                                            //  onLoad={this._onLoad}
                                                            //   onError={status !== 3 ? this._onError : undefined} // prevent infinite-loop bug
                                                        />
                                                    </TouchableOpacity>;
                                                })
                                            }

                                        </View>
                                        <View style={{
                                            width: '100%',
                                            flexDirection: 'row',
                                            marginVertical: moderateScale(8),
                                        }}>
                                            <View
                                                style={{
                                                    flex: .5,
                                                    flexDirection: 'row',
                                                }}>

                                                {
                                                    <TouchableOpacity
                                                        onPress={
                                                            () => listVideo.length > 0 ? this.setState({
                                                                    visibleModal: 'selectVideo',
                                                                    visibleModalMenu: '',

                                                                    // pathVideo: checkVideo,
                                                                    sliderList: listVideo,

                                                                    slider1ActiveSlide: 0,
                                                                })

                                                                :
                                                                null
                                                        }

                                                        style={{
                                                            // flex: .33,
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                               marginStart: moderateScale(6)
                                                        }}>
                                                        <HMIcon name={'md-videocam'}
                                                                style={{
                                                                    alignSelf: 'center',
                                                                    // width: moderateScale(14),
                                                                    color: checkVideo ? Colors.colorPrimaryDark : Colors.gray,
                                                                    fontSize: Platform.OS === 'ios' ? moderateScale(22) : moderateScale(20),
                                                                    textAlign: 'center',
                                                                }}/>
                                                    </TouchableOpacity>

                                                }

                                                {

                                                    //
                                                    // <TouchableOpacity
                                                    //     onPress={
                                                    //         () => listImage.length > 0 ? this.setState({
                                                    //                 visibleModal: 'selectSlider',
                                                    //                 visibleModalMenu: '',
                                                    //
                                                    //                 sliderList: listImage,
                                                    //                 slider1ActiveSlide: 0,
                                                    //             })
                                                    //             :
                                                    //             null
                                                    //
                                                    //     }
                                                    //
                                                    //     style={{
                                                    //         // flex: .33,
                                                    //         flexDirection: 'row',
                                                    //         alignItems: 'center',
                                                    //         justifyContent: 'center',
                                                    //         marginHorizontal: moderateScale(5),
                                                    //     }}>
                                                    //     <HMIcon name={'images'}
                                                    //             style={{
                                                    //                 alignSelf: 'center',
                                                    //                 // width: moderateScale(14),
                                                    //                 color: listImage.length > 0 ? Colors.colorPrimaryDark : Colors.gray,
                                                    //                 fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                    //                 textAlign: 'center',
                                                    //             }}/>
                                                    // </TouchableOpacity>
                                                    //
                                                    //
                                                }
                                                {


                                                    <TouchableOpacity

                                                        onPress={
                                                            () => listVoice.length > 0 ? this.setState({
                                                                    visibleModal: 'selectVideo',
                                                                    visibleModalMenu: '',

                                                                    //   pathVideo: checkAudio,
                                                                    sliderList: listVoice,

                                                                    slider1ActiveSlide: 0,
                                                                    // visibleModal: "selectaudio",
                                                                    // pathAudio: checkAudio,
                                                                })
                                                                : null
                                                        }
                                                        style={{
                                                            // flex: .33,
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginStart: moderateScale(6)
                                                        }}>
                                                        <HMIcon name={'md-mic'} style={{
                                                            alignSelf: 'center',
                                                            // width: moderateScale(14),
                                                            color: listVoice.length > 0 ? Colors.colorPrimaryDark : Colors.gray,
                                                            fontSize: Platform.OS === 'ios' ? moderateScale(22) : moderateScale(20),
                                                            textAlign: 'center',
                                                        }}/>
                                                    </TouchableOpacity>

                                                }
                                                {


                                                    <TouchableOpacity

                                                        onPress={
                                                            () => listOthers.length > 0 ? this.setState({
                                                                    visibleModal: 'selectListOthers',
                                                                    visibleModalMenu: '',

                                                                    sliderList: listOthers,
                                                                    slider1ActiveSlide: 0,
                                                                    // visibleModal: "selectaudio",
                                                                    // pathAudio: checkAudio,
                                                                })
                                                                : null
                                                        }
                                                        style={{
                                                            // flex: .33,
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            //  marginHorizontal: moderateScale(5)
                                                        }}>
                                                        <HMIcon name={'ios-attach'}
                                                                style={{
                                                                    alignSelf: 'center',
                                                                    // width: moderateScale(14),
                                                                    color: listOthers.length > 0 ? Colors.colorPrimaryDark : Colors.gray,
                                                                    fontSize: Platform.OS === 'ios' ? moderateScale(22) : moderateScale(20),
                                                                    textAlign: 'center',
                                                                }}/>
                                                    </TouchableOpacity>

                                                }

                                            </View>
                                            {

                                                <View
                                                    style={{
                                                        flex: .5,
                                                        flexDirection: 'row',
                                                        justifyContent: 'flex-end',
                                                    }}>
                                                    {/*<HMIcon name={"ios-text"} style={{*/}
                                                    {/*alignSelf: 'center',*/}
                                                    {/*// width: moderateScale(14),*/}
                                                    {/*color: Colors.colorDark,*/}
                                                    {/*marginHorizontal: moderateScale(5),*/}
                                                    {/*fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),*/}
                                                    {/*textAlign: 'center'*/}
                                                    {/*}}/>*/}
                                                    {/*<HMTextView*/}

                                                    {/*//type={"bold"}*/}
                                                    {/**/}
                                                    {/*style={{*/}
                                                    {/*fontSize: moderateScale(11),*/}
                                                    {/*color: Colors.gray,*/}

                                                    {/*// marginTop: moderateScale(10)*/}
                                                    {/*}}*/}
                                                    {/*text={item.lastWork && item.lastWork.length > 0 ? item.lastWork.length : 0}*/}
                                                    {/*//   text={"98/03/21"}*/}
                                                    {/*/>*/}
                                                </View>
                                            }

                                        </View>


                                    </View>

                                </View>
                            );
                        }

                        }
                        //renderItem={this.renderItem}
                        keyExtractor={(item, index) => index.toString()}
                        ListEmptyComponent={() =>
                            null}
                        // //  ItemSeparatorComponent={this.renderSeparator.bind(this)}
                        // ListFooterComponent={this.renderFooter.bind(this)}
                        // refreshing={this.props.showRefresh}
                        // onRefresh={this.handleRefresh.bind(this)}
                        // onEndReached={this.handleLoadMore.bind(this)}
                        // onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                    />


                </View>;

            case 5:
                ///  let building = this.getNameBuilding();
                return <View>

                    <HMSelectInput
                        onValueChange={(value, itemInput) => {
                            //  console.log("value000",value)
                            this.setState({
                                typeBuilding: value,
                                Building: itemInput,
                            });
                        }}
                        error={this.state.errorSelectInput}

                        requestServerRetry={container.getServerTypeBuilding}
                        requestServer={this.state.TypeBuildingList.length > 0 ? null : container.getServerTypeBuilding}
                        loading={this.state.isLoadingSelectInput}
                        value={this.state.typeBuilding ? this.state.typeBuilding : i18n.t('constant.SelectItem')}
                        // value={this.state.typeBuilding?(this.state.TypeBuildingList.length > 0 ? building.label :this.state.typeBuilding): i18n.t('constant.SelectItem')}
                        index={this.state.Building?.index}
                        itemSelectInput={this.state.Building}
                        //  value={"ghjghhg"}
                        text={i18n.t('constant.AccountType')}
                        // options={options}
                        options={this.state.TypeBuildingList}
                    />

                    <HMTextInputEfects
                        onRef={scroll => container['inputOwnerName'] = scroll}

                        refName={'OwnerName'}

                        type={'CostumeFumi'}
                        value={this.state.OwnerName}

                        label={i18n.t('constant.OwnerName')}
                        onChangeText={text => this.setState({
                            OwnerName: text,
                        })}
                        iconClass={'FontAwesomeIcon'}
                        iconName={'phone'}
                        //keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => this._focusNextField('inputTenantName')}
                        containerStyle={{width: '99.8%'}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(4),
                        }}
                        border={true}

                    />


                    <HMTextInputEfects
                        onRef={scroll => container['inputTenantName'] = scroll}

                        refName={'TenantName'}

                        type={'CostumeFumi'}
                        value={this.state.TenantName}

                        label={i18n.t('constant.TenantName')}
                        onChangeText={text => this.setState({
                            TenantName: text,
                        })}
                        iconClass={'FontAwesomeIcon'}
                        iconName={'phone'}
                        //keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => this._focusNextField('inputNumberOfFloors')}
                        containerStyle={{width: '99.8%'}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(4),
                        }}
                        border={true}


                    />

                    <View style={{flexDirection: 'row', width: '96%', alignSelf: 'center'}}>

                        <View style={{flex: .5}}>
                            <HMTextInputEfects
                                onRef={scroll => container['inputNumberOfFloors'] = scroll}

                                refName={'NumberOfFloors'}

                                type={'CostumeFumi'}
                                value={this.state.NumberOfFloors}

                                label={i18n.t('constant.NumberOfFloors')}
                                onChangeText={text => this.setState({
                                    NumberOfFloors: text,
                                })}
                                iconClass={'FontAwesomeIcon'}
                                iconName={'phone'}
                                keyboardType={'number-pad'}
                                // _scroll={this._scroll}

                                // secureTextEntry={true}
                                onSubmitEditing={() => this._focusNextField('inputNumberOfUnitsPerFloor')}
                                containerStyle={{width: '99%'}}
                                containerInputStyle={{
                                    borderWidth: moderateScale(1),

                                    borderRadius: moderateScale(10),
                                    // overflow: 'hidden',
                                    marginVertical: moderateScale(4),
                                }}
                                border={true}

                            />
                        </View>
                        <View style={{flex: .5}}>
                            <HMTextInputEfects
                                onRef={scroll => container['inputNumberOfUnitsPerFloor'] = scroll}

                                refName={'NumberOfUnitsPerFloor'}

                                type={'CostumeFumi'}
                                value={this.state.NumberOfUnitsPerFloor}

                                label={i18n.t('constant.NumberOfUnitsPerFloor')}
                                onChangeText={text => this.setState({
                                    NumberOfUnitsPerFloor: text,
                                })}
                                iconClass={'FontAwesomeIcon'}
                                iconName={'phone'}
                                keyboardType={'number-pad'}
                                // _scroll={this._scroll}

                                // secureTextEntry={true}
                                //  onSubmitEditing={() => this._focusNextField("inputAtmosphericConditions")}
                                onSubmitEditing={() => {
                                }}
                                containerStyle={{width: '99%'}}
                                containerInputStyle={{
                                    borderWidth: moderateScale(1),

                                    borderRadius: moderateScale(10),
                                    // overflow: 'hidden',
                                    marginVertical: moderateScale(4),
                                }}
                                border={true}

                            />
                        </View>

                    </View>


                    {/*<HMTextInputEfects*/}
                    {/*onRef={scroll => container["inputAtmosphericConditions"] = scroll}*/}

                    {/*refName={"AtmosphericConditions"}*/}

                    {/*type={"CostumeFumi"}*/}
                    {/*value={this.state.AtmosphericConditions}*/}

                    {/*label={i18n.t('constant.AtmosphericConditions')}*/}
                    {/*onChangeText={text => this.setState({*/}
                    {/*AtmosphericConditions: text*/}
                    {/*})}*/}
                    {/*iconClass={"FontAwesomeIcon"}*/}
                    {/*iconName={'phone'}*/}
                    {/*// keyboardType={'number-pad'}*/}
                    {/*// _scroll={this._scroll}*/}

                    {/*// secureTextEntry={true}*/}
                    {/*onSubmitEditing={() => {*/}
                    {/*}}*/}
                    {/*containerStyle={{}}*/}
                    {/*containerInputStyle={{*/}
                    {/*borderWidth: moderateScale(1),*/}

                    {/*borderRadius: moderateScale(10),*/}
                    {/*// overflow: 'hidden',*/}
                    {/*marginVertical: moderateScale(4)*/}
                    {/*}}*/}
                    {/*border={true} */}

                    {/*/>*/}
                </View>;
            case 6:
                return <View style={{width: '100%'}}>
                    {
                        this.state.showListModal ?
                            <View>
                                <EmptyView empty={this.state.DamagesList && this.state.DamagesList.length === 0}/>

                                <FlatList
                                    data={this.state.DamagesList}
                                    // data={[
                                    //     {
                                    //         id: 1,
                                    //         date: "1399/03/12",
                                    //         firstName: "احمد",
                                    //         lastName: "خلیلی",
                                    //         age: "28",
                                    //         education: "کارشناسی",
                                    //         national_code: "0520525264",
                                    //         job: "برنامه نویس",
                                    //         type: "غیر مامور",
                                    //         gender: "آقا",
                                    //         typeHealth: "مصدومیت",
                                    //         desc: "پای مصدوم بشدت آسیب دیده",
                                    //         place: "اراک خ سی متری فوتبال کوچه شهید کریم پور بالاتر از پارک فجر للللللللللل اتیلسبالسایبلتا اسیلبالالسیالیاساتیسلایل",
                                    //     }, {
                                    //         id: 1,
                                    //         date: "1399/03/12",
                                    //         firstName: "احمد",
                                    //         lastName: "خلیلی",
                                    //         age: "28",
                                    //         education: "کارشناسی",
                                    //         national_code: "0520525264",
                                    //         job: "برنامه نویس",
                                    //
                                    //         type: "غیر مامور",
                                    //         gender: "آقا",
                                    //         typeHealth: "مصدومیت",
                                    //         desc: "پای مصدوم بشدت آسیب دیده",
                                    //         place: "اراک خ سی متری فوتبال کوچه شهید کریم پور بالاتر از پارک فجر",
                                    //     }, {
                                    //         id: 1,
                                    //         date: "1399/03/12",
                                    //         firstName: "احمد",
                                    //         lastName: "خلیلی",
                                    //         age: "28",
                                    //         education: "کارشناسی",
                                    //         national_code: "0520525264",
                                    //         job: "برنامه نویس",
                                    //
                                    //         type: "غیر مامور",
                                    //         gender: "آقا",
                                    //         typeHealth: "مصدومیت",
                                    //         desc: "پای مصدوم بشدت آسیب دیده",
                                    //         place: "اراک خ سی متری فوتبال کوچه شهید کریم پور بالاتر از پارک فجر",
                                    //     }, {
                                    //         id: 1,
                                    //         date: "1399/03/12",
                                    //         firstName: "احمد",
                                    //         lastName: "خلیلی",
                                    //         age: "28",
                                    //         education: "کارشناسی",
                                    //         national_code: "0520525264",
                                    //         job: "برنامه نویس",
                                    //
                                    //         type: "غیر مامور",
                                    //         gender: "آقا",
                                    //         typeHealth: "مصدومیت",
                                    //         desc: "پای مصدوم بشدت آسیب دیده",
                                    //         place: "اراک خ سی متری فوتبال کوچه شهید کریم پور بالاتر از پارک فجر",
                                    //     }, {
                                    //         id: 1,
                                    //         date: "1399/03/12",
                                    //         firstName: "احمد",
                                    //         lastName: "خلیلی",
                                    //         age: "28",
                                    //         education: "کارشناسی",
                                    //         national_code: "0520525264",
                                    //         job: "برنامه نویس",
                                    //
                                    //         type: "غیر مامور",
                                    //         gender: "آقا",
                                    //         typeHealth: "مصدومیت",
                                    //         desc: "پای مصدوم بشدت آسیب دیده",
                                    //         place: "اراک خ سی متری فوتبال کوچه شهید کریم پور بالاتر از پارک فجر",
                                    //     },
                                    //
                                    // ]}
                                    renderItem={({item, index}) => {
                                        return <View
                                            style={{
                                                flex: 1,
                                                overflow: 'hidden',
                                                //height:  moderateScale(100),
                                                // padding: moderateScale(4),
                                                marginVertical: moderateScale(5),
                                                borderWidth: moderateScale(1),
                                                borderRadius: moderateScale(2),
                                                borderColor: '#ddd',
                                                borderBottomWidth: 0,
                                                shadowColor: '#000',
                                                shadowOffset: {width: 0, height: moderateScale(.7)},
                                                shadowOpacity: 0.6,
                                                shadowRadius: moderateScale(2),
                                                elevation: moderateScale(1),
                                                // marginLeft: moderateScale(1),
                                                // marginRight: moderateScale(1),
                                                // marginTop: moderateScale(1),
                                                // marginBottom: moderateScale(1),
                                                backgroundColor: Colors.light3,
                                            }}>

                                            <View style={{padding: moderateScale(6)}}>

                                                <View style={{flex: 1, flexDirection: 'row'}}>
                                                    <View style={{flexDirection: 'row', flex: .5}}>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={'نام' + ' : '}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.blackLight,
                                                                fontSize: moderateScale(11),


                                                            }}/>

                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={item.Name}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.colorDark,
                                                                fontSize: moderateScale(10),


                                                            }}/>
                                                    </View>
                                                    <View style={{flexDirection: 'row', flex: .5}}>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={'نام خانوادگی' + ' : '}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.blackLight,
                                                                fontSize: moderateScale(11),


                                                            }}/>

                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={item.Family}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.colorDark,
                                                                fontSize: moderateScale(10),


                                                            }}/>
                                                    </View>
                                                </View>
                                                <View style={{flex: 1, flexDirection: 'row'}}>
                                                    <View style={{flexDirection: 'row', flex: .5}}>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={'سن' + ' : '}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.blackLight,
                                                                fontSize: moderateScale(11),


                                                            }}/>

                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={item.Old}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.colorDark,
                                                                fontSize: moderateScale(10),


                                                            }}/>
                                                    </View>
                                                    <View style={{flexDirection: 'row', flex: .5}}>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={'تحصیلات' + ' : '}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.blackLight,
                                                                fontSize: moderateScale(11),


                                                            }}/>

                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={item.Education}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.colorDark,
                                                                fontSize: moderateScale(10),


                                                            }}/>
                                                    </View>
                                                </View>
                                                <View style={{flex: 1, flexDirection: 'row'}}>
                                                    <View style={{flexDirection: 'row', flex: .5}}>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={'شماره ملی' + ' : '}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.blackLight,
                                                                fontSize: moderateScale(11),


                                                            }}/>

                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={item.NationalCode}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.colorDark,
                                                                fontSize: moderateScale(10),


                                                            }}/>
                                                    </View>
                                                    <View style={{flexDirection: 'row', flex: .5}}>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={'شغل' + ' : '}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.blackLight,
                                                                fontSize: moderateScale(11),


                                                            }}/>

                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={item.Job}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.colorDark,
                                                                fontSize: moderateScale(10),


                                                            }}/>
                                                    </View>
                                                </View>

                                                <View style={{flex: 1, flexDirection: 'row'}}>
                                                    <View style={{flexDirection: 'row', flex: .5}}>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={'نوع' + ' : '}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.blackLight,
                                                                fontSize: moderateScale(11),


                                                            }}/>

                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={item.TypeBodyText}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.colorDark,
                                                                fontSize: moderateScale(10),


                                                            }}/>
                                                    </View>
                                                    <View style={{flexDirection: 'row', flex: .5}}>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={'جنسیت' + ' : '}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.blackLight,
                                                                fontSize: moderateScale(11),


                                                            }}/>

                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={item.MaleText}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.colorDark,
                                                                fontSize: moderateScale(10),


                                                            }}/>
                                                    </View>

                                                </View>
                                                <View style={{flex: 1, flexDirection: 'row'}}>
                                                    <View style={{flexDirection: 'row', flex: .5}}>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={'نوع صدمه' + ' : '}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.blackLight,
                                                                fontSize: moderateScale(11),


                                                            }}/>

                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={item.DeathText}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.colorDark,
                                                                fontSize: moderateScale(10),


                                                            }}/>
                                                    </View>
                                                    <View style={{flexDirection: 'row', flex: .5}}>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={'تاریخ' + ' : '}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.blackLight,
                                                                fontSize: moderateScale(11),


                                                            }}/>

                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={item.date}
                                                            type={'bold'}
                                                            style={{
                                                                textAlign: 'center',
                                                                color: Colors.colorDark,
                                                                fontSize: moderateScale(10),


                                                            }}/>
                                                    </View>
                                                </View>
                                                <View style={{flexDirection: 'row', flex: 1}}>
                                                    <View style={{flexDirection: 'row', flex: .5}}>
                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={'محل اعزام' + ' : '}
                                                            type={'bold'}
                                                            style={{
                                                                // textAlign: "center",
                                                                color: Colors.blackLight,
                                                                fontSize: moderateScale(11),


                                                            }}/>

                                                        <HMTextView
                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                            text={item.PlaceSend}
                                                            type={'bold'}
                                                            style={{
                                                                //textAlign: "center",
                                                                color: Colors.colorDark,
                                                                fontSize: moderateScale(10),


                                                            }}
                                                            styleRoot={{flex: 1, flexWrap: 'wrap'}}
                                                        />
                                                    </View>
                                                    {
                                                        item.TypeBody != 0 ?
                                                            null
                                                            :
                                                            <View style={{flexDirection: 'row', flex: .5}}>
                                                                <HMTextView
                                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                    text={'وظیفه مامور' + ' : '}
                                                                    type={'bold'}
                                                                    style={{
                                                                        // textAlign: "center",
                                                                        color: Colors.blackLight,
                                                                        fontSize: moderateScale(11),


                                                                    }}/>

                                                                <HMTextView
                                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                    text={item.TaskAgent}
                                                                    type={'bold'}
                                                                    style={{
                                                                        //textAlign: "center",
                                                                        color: Colors.colorDark,
                                                                        fontSize: moderateScale(10),


                                                                    }}
                                                                    styleRoot={{flex: 1, flexWrap: 'wrap'}}
                                                                />
                                                            </View>


                                                    }


                                                </View>
                                                {
                                                    item.TypeBody != 0 ?
                                                        null
                                                        :
                                                        <View style={{width: '100%'}}>
                                                            <View style={{flexDirection: 'row', flex: 1}}>


                                                                <View style={{flexDirection: 'row', flex: .5}}>
                                                                    <HMTextView
                                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                        text={'مکان مامور' + ' : '}
                                                                        type={'bold'}
                                                                        style={{
                                                                            // textAlign: "center",
                                                                            color: Colors.blackLight,
                                                                            fontSize: moderateScale(11),


                                                                        }}/>

                                                                    <HMTextView
                                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                        text={item.AddressAgent}
                                                                        type={'bold'}
                                                                        style={{
                                                                            //textAlign: "center",
                                                                            color: Colors.colorDark,
                                                                            fontSize: moderateScale(10),


                                                                        }}
                                                                        styleRoot={{flex: 1, flexWrap: 'wrap'}}
                                                                    />
                                                                </View>
                                                                <View style={{flexDirection: 'row', flex: .5}}>
                                                                    <HMTextView
                                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                        text={'بخش آسیب دیده مامور' + ' : '}
                                                                        type={'bold'}
                                                                        style={{
                                                                            // textAlign: "center",
                                                                            color: Colors.blackLight,
                                                                            fontSize: moderateScale(11),


                                                                        }}/>

                                                                    <HMTextView
                                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                        text={item.InjuryAgent}
                                                                        type={'bold'}
                                                                        style={{
                                                                            //textAlign: "center",
                                                                            color: Colors.colorDark,
                                                                            fontSize: moderateScale(10),


                                                                        }}
                                                                        styleRoot={{flex: 1, flexWrap: 'wrap'}}
                                                                    />
                                                                </View>
                                                            </View>
                                                            <View style={{flexDirection: 'row', flex: 1}}>


                                                                <View style={{flexDirection: 'row', flex: .5}}>
                                                                    <HMTextView
                                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                        text={'علت آسیب مامور' + ' : '}
                                                                        type={'bold'}
                                                                        style={{
                                                                            // textAlign: "center",
                                                                            color: Colors.blackLight,
                                                                            fontSize: moderateScale(11),


                                                                        }}/>

                                                                    <HMTextView
                                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                        text={item.DescriptionAgent}
                                                                        type={'bold'}
                                                                        style={{
                                                                            //textAlign: "center",
                                                                            color: Colors.colorDark,
                                                                            fontSize: moderateScale(10),


                                                                        }}
                                                                        styleRoot={{flex: 1, flexWrap: 'wrap'}}
                                                                    />
                                                                </View>
                                                                <View style={{flexDirection: 'row', flex: .5}}>
                                                                    <HMTextView
                                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                        text={'تجهیزات ایمنی مامور' + ' : '}
                                                                        type={'bold'}
                                                                        style={{
                                                                            // textAlign: "center",
                                                                            color: Colors.blackLight,
                                                                            fontSize: moderateScale(11),


                                                                        }}/>

                                                                    <HMTextView
                                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                        text={item.EquipmentAgent}
                                                                        type={'bold'}
                                                                        style={{
                                                                            //textAlign: "center",
                                                                            color: Colors.colorDark,
                                                                            fontSize: moderateScale(10),


                                                                        }}
                                                                        styleRoot={{flex: 1, flexWrap: 'wrap'}}
                                                                    />
                                                                </View>
                                                            </View>
                                                        </View>
                                                }
                                                <View style={{flexDirection: 'row'}}>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={'توضیحات' + ' : '}
                                                        type={'bold'}
                                                        style={{
                                                            textAlign: 'center',
                                                            color: Colors.blackLight,
                                                            fontSize: moderateScale(11),


                                                        }}

                                                    />

                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={item.Comment}
                                                        type={'bold'}
                                                        style={{
                                                            textAlign: 'center',
                                                            color: Colors.colorDark,
                                                            fontSize: moderateScale(10),


                                                        }}
                                                        styleRoot={{flex: 1, flexWrap: 'wrap'}}

                                                    />
                                                </View>

                                            </View>
                                        </View>;
                                    }}
                                    //renderItem={this.renderItem}
                                    keyExtractor={(item, index) => index.toString()}
                                    ListEmptyComponent={() =>
                                        null}
                                    // //  ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                    // ListFooterComponent={this.renderFooter.bind(this)}
                                    // refreshing={this.props.showRefresh}
                                    // onRefresh={this.handleRefresh.bind(this)}
                                    // onEndReached={this.handleLoadMore.bind(this)}
                                    // onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                />

                            </View>
                            :

                            <View style={{width: '100%'}}>

                                {/*<HMSelectInput*/}
                                {/*onValueChange={(value) => {*/}
                                {/*this.setState({*/}
                                {/*typeBuilding: value*/}
                                {/*})*/}
                                {/*}}*/}

                                {/*loading={false} value={i18n.t('constant.SelectItem')}*/}
                                {/*text={i18n.t('constant.type') + " " + i18n.t('constant.User')}*/}
                                {/*options={options}/>*/}


                                <View
                                    style={{

                                        //  flexDirection: 'row',
                                        width: '96%',
                                        alignSelf: 'center',
                                        //  alignItems: 'center',
                                        marginTop: moderateScale(6),
                                    }}>
                                    <HMTextView
                                        //  numberOfLines={1}
                                        // type={'bold'}
                                        text={i18n.t('constant.type') + ' : '}
                                        // text={"در دو هفته اخیر با چند نفر در ارتباط بودید؟"}
                                        style={{
                                            //marginTop: moderateScale(18),
                                            marginHorizontal: moderateScale(6),
                                            color: Colors.blackLight,
                                            // marginEnd: moderateScale(10),
                                            fontSize: moderateScale(14),
                                            textAlign: 'center',
                                            //  marginHorizontal: moderateScale(8)

                                        }}/>


                                    <HMListCheckBox
                                        data={{
                                            list: [
                                                {id: 0, name: i18n.t('constant.Agent')},
                                                {id: 2, name: i18n.t('constant.NoAgent')},

                                            ],
                                            /*      list: [
                                                      {
                                                          id: 1,
                                                          locale: 'fa',
                                                          list: [
                                                              {id: 1, name: '20 نفر'}, {id: 2, name: '40 نفر'}, {
                                                                  id: 3,
                                                                  name: '60 نفر'
                                                              }, {id: 4, name: '80 نفر'},
                                                          ]
                                                      },
                                                      {
                                                          id: 1,
                                                          locale: 'en',
                                                          list: [
                                                              {id: 1, name: '20 people'}, {id: 2, name: '40 people'}, {
                                                                  id: 3,
                                                                  name: '60 people'
                                                              }, {id: 4, name: '80 people'},
                                                          ]
                                                      },
                                                      {
                                                          id: 1,
                                                          locale: 'ku',
                                                          list: [
                                                              {id: 1, name: '20 كەس'}, {id: 2, name: '40 كەس'}, {
                                                                  id: 3,
                                                                  name: '60 كەس'
                                                              }, {id: 4, name: '80 كەس'},
                                                          ]
                                                      },
                                                  ].find((obj) => obj.locale == i18n.locale).list,*/
                                            indexSelect: this.state['indexSelectCheckBoxtype'],
                                            name: 'type',

                                        }}
                                        onPress={this.onPressSelectCheckBox
                                        }

                                    />
                                </View>
                                {

                                    this.state['indexSelectCheckBoxtype'] == 0 ?

                                        <View style={{
                                            width: '96%', alignSelf: 'center',
                                        }}>

                                            <HMSelectInput
                                                styleRoot={{marginTop: moderateScale(14)}}
                                                onValueChange={(value, itemInput) => {
                                                    this.setState({
                                                        UserAgent: value,
                                                        itemInputUserAgent: itemInput,

                                                    });
                                                }}
                                                //   requestServer={this.state.TypeBuildingList.length > 0 ? null : this.getServerEquipmentItem}
                                                requestServerRetry={container.getServerUserAgents}

                                                requestServer={this.state.UserAgentList.length > 0 ? null : container.getServerUserAgents}
                                                //value={this.state.DeviceType >= 0 ? "ghjhj": i18n.t('constant.SelectItem')}
                                                value={this.state.UserAgent ? this.state.UserAgent : i18n.t('constant.SelectItem')}
                                                // index={building.index}
                                                itemSelectInput={this.state.itemInputUserAgent}

                                                //    error={this.state.errorSelectInput}
                                                //   loading={this.state.isLoadingSelectInput}
                                                text={'مامور'}
                                                options={this.state.UserAgentList}
                                                error={this.state.UserAgentError}
                                                loading={this.state.isLoadingUserAgent}

                                            />

                                            <HMTextInputEfects
                                                onRef={scroll => container['inputTaskAgent'] = scroll}

                                                refName={'TaskAgent'}

                                                type={'CostumeFumi'}
                                                value={this.state.TaskAgent}

                                                label={'وظیفه و کار مامور در لحظه جراحت چه بوده است؟'}
                                                onChangeText={text => this.setState({
                                                    TaskAgent: text,
                                                })}
                                                iconClass={'FontAwesomeIcon'}
                                                iconName={'phone'}
                                                // keyboardType={'number-pad'}
                                                // _scroll={this._scroll}

                                                // secureTextEntry={true}
                                                onSubmitEditing={() => this._focusNextField('inputAddressAgent')}

                                                containerStyle={{width: '99.8%'}}
                                                containerInputStyle={{
                                                    borderWidth: moderateScale(1),

                                                    borderRadius: moderateScale(10),
                                                    // overflow: 'hidden',
                                                    marginVertical: moderateScale(4),
                                                }}
                                                border={true}
                                            />


                                            <HMTextInputEfects
                                                onRef={scroll => container['inputAddressAgent'] = scroll}

                                                refName={'AddressAgent'}

                                                type={'CostumeFumi'}
                                                value={this.state.AddressAgent}

                                                label={'مکان دقیق مامور در هنگام آسیب کجا بوده است؟'}
                                                onChangeText={text => this.setState({
                                                    AddressAgent: text,
                                                })}
                                                iconClass={'FontAwesomeIcon'}
                                                iconName={'phone'}
                                                // keyboardType={'number-pad'}
                                                // _scroll={this._scroll}

                                                // secureTextEntry={true}
                                                onSubmitEditing={() => this._focusNextField('inputInjuryAgent')}

                                                containerStyle={{width: '99.8%'}}
                                                containerInputStyle={{
                                                    borderWidth: moderateScale(1),

                                                    borderRadius: moderateScale(10),
                                                    // overflow: 'hidden',
                                                    marginVertical: moderateScale(4),
                                                }}
                                                border={true}

                                            />


                                            <HMTextInputEfects
                                                onRef={scroll => container['inputInjuryAgent'] = scroll}

                                                refName={'InjuryAgent'}

                                                type={'CostumeFumi'}
                                                value={this.state.InjuryAgent}

                                                label={'کدام بخش از بدن مامور آسیب دیده است؟ علائم شهودی آسیب ها را توضیح دهید'}
                                                onChangeText={text => this.setState({
                                                    InjuryAgent: text,
                                                })}
                                                iconClass={'FontAwesomeIcon'}
                                                iconName={'phone'}
                                                // keyboardType={'number-pad'}
                                                // _scroll={this._scroll}

                                                // secureTextEntry={true}
                                                onSubmitEditing={() => this._focusNextField('inputDescriptionAgent')}

                                                containerStyle={{width: '99.8%'}}
                                                containerInputStyle={{
                                                    borderWidth: moderateScale(1),

                                                    borderRadius: moderateScale(10),
                                                    // overflow: 'hidden',
                                                    marginVertical: moderateScale(4),
                                                }}
                                                border={true}

                                            />


                                            <HMTextInputEfects
                                                onRef={scroll => container['inputDescriptionAgent'] = scroll}

                                                refName={'DescriptionAgent'}

                                                type={'CostumeFumi'}
                                                value={this.state.DescriptionAgent}

                                                label={'علت اصلی آسیب، علت های کمک کننده و اشیاء درگیر (مواد سمی و ...) را توضیح دهید'}
                                                onChangeText={text => this.setState({
                                                    DescriptionAgent: text,
                                                })}
                                                iconClass={'FontAwesomeIcon'}
                                                iconName={'phone'}
                                                // keyboardType={'number-pad'}
                                                // _scroll={this._scroll}

                                                // secureTextEntry={true}
                                                onSubmitEditing={() => this._focusNextField('inputEquipmentAgent')}

                                                containerStyle={{width: '99.8%'}}
                                                containerInputStyle={{
                                                    borderWidth: moderateScale(1),

                                                    borderRadius: moderateScale(10),
                                                    // overflow: 'hidden',
                                                    marginVertical: moderateScale(4),
                                                }}
                                                border={true}

                                            />

                                            <HMTextInputEfects
                                                onRef={scroll => container['inputEquipmentAgent'] = scroll}

                                                refName={'EquipmentAgent'}

                                                type={'CostumeFumi'}
                                                value={this.state.EquipmentAgent}

                                                label={'آیا مامور تجهیزات ایمنی لازم را داشته است توضیح دهید'}
                                                onChangeText={text => this.setState({
                                                    EquipmentAgent: text,
                                                })}
                                                iconClass={'FontAwesomeIcon'}
                                                iconName={'phone'}
                                                // keyboardType={'number-pad'}
                                                // _scroll={this._scroll}

                                                // secureTextEntry={true}
                                                onSubmitEditing={() => this._focusNextField('inputTypeInjury')}

                                                containerStyle={{width: '99.8%'}}
                                                containerInputStyle={{
                                                    borderWidth: moderateScale(1),

                                                    borderRadius: moderateScale(10),
                                                    // overflow: 'hidden',
                                                    marginVertical: moderateScale(4),
                                                }}
                                                border={true}

                                            />

                                        </View>
                                        :
                                        <View style={{width: '100%', alignSelf: 'center'}}>
                                            <View style={{
                                                flexDirection: 'row',
                                                width: '96%',
                                                alignSelf: 'center',
                                                marginTop: moderateScale(8),
                                            }}>

                                                <View style={{flex: .5}}>
                                                    <HMTextInputEfects
                                                        onRef={scroll => container['inputFirst_name'] = scroll}

                                                        refName={'First_name'}

                                                        type={'CostumeFumi'}
                                                        value={this.state.First_name}

                                                        label={i18n.t('constant.First_name')}
                                                        onChangeText={text => this.setState({
                                                            First_name: text,
                                                        })}
                                                        iconClass={'FontAwesomeIcon'}
                                                        iconName={'phone'}
                                                        //keyboardType={'number-pad'}
                                                        // _scroll={this._scroll}

                                                        // secureTextEntry={true}
                                                        onSubmitEditing={() => this._focusNextField('inputLast_name')}
                                                        containerStyle={{width: '99%'}}
                                                        containerInputStyle={{
                                                            borderWidth: moderateScale(1),

                                                            borderRadius: moderateScale(10),
                                                            // overflow: 'hidden',
                                                            marginVertical: moderateScale(4),
                                                        }}
                                                        border={true}

                                                    />
                                                </View>
                                                <View style={{flex: .5}}>
                                                    <HMTextInputEfects
                                                        onRef={scroll => container['inputLast_name'] = scroll}

                                                        refName={'Last_name'}

                                                        type={'CostumeFumi'}
                                                        value={this.state.Last_name}

                                                        label={i18n.t('constant.Last_name')}
                                                        onChangeText={text => this.setState({
                                                            Last_name: text,
                                                        })}
                                                        iconClass={'FontAwesomeIcon'}
                                                        iconName={'phone'}
                                                        //keyboardType={'number-pad'}
                                                        // _scroll={this._scroll}

                                                        // secureTextEntry={true}
                                                        onSubmitEditing={() => this._focusNextField('inputNationalCode')}
                                                        containerStyle={{width: '99%'}}
                                                        containerInputStyle={{
                                                            borderWidth: moderateScale(1),

                                                            borderRadius: moderateScale(10),
                                                            // overflow: 'hidden',
                                                            marginVertical: moderateScale(4),
                                                        }}
                                                        border={true}

                                                    />
                                                </View>

                                            </View>
                                            <View style={{flexDirection: 'row', width: '96%', alignSelf: 'center'}}>

                                                <View style={{flex: .5}}>
                                                    <HMSelectInput
                                                        onValueChange={(value, itemInput, index) => {

                                                            this.setState({
                                                                itemSelectInputAge: _Ages[index],
                                                                typeAge: value,
                                                                Age: itemInput,
                                                            });
                                                        }}
                                                        // error={this.state.errorSelectInput}

                                                        //requestServerRetry={container.getServerTypeEducation}
                                                        //  requestServer={this.state.TypeBuildingList.length > 0 ? null : container.getServerTypeEducation}
                                                        // loading={this.state.isLoadingSelectInput}
                                                        value={this.state.typeAge ? this.state.typeAge : i18n.t('constant.SelectItem')}
                                                        //index={building.index}
                                                        itemSelectInput={this.state.Age}
                                                        //  value={"ghjghhg"}
                                                        text={i18n.t('constant.Age')}
                                                        // options={options}
                                                        options={_Ages}
                                                        styleRoot={{width: '99%'}}
                                                    />
                                                    {/*  <HMTextInputEfects
                                        onRef={scroll => container["inputAge"] = scroll}

                                        refName={"Age"}

                                        type={"CostumeFumi"}
                                        value={this.state.Age}

                                        label={i18n.t('constant.Age')}
                                        onChangeText={text => this.setState({
                                            Age: text
                                        })}
                                        iconClass={"FontAwesomeIcon"}
                                        iconName={'phone'}
                                        keyboardType={'number-pad'}
                                        // _scroll={this._scroll}

                                        // secureTextEntry={true}
                                        onSubmitEditing={() => this._focusNextField("inputEducation")}
                                        containerStyle={{}}
                                        containerInputStyle={{
                                            borderWidth: moderateScale(1),

                                            borderRadius: moderateScale(10),
                                            // overflow: 'hidden',
                                            marginVertical: moderateScale(4)
                                        }}
                                        border={true}

                                    />*/}
                                                </View>
                                                <View style={{flex: .5, justifyContent: 'center'}}>
                                                    <HMSelectInput
                                                        onValueChange={(value, itemInput, index) => {

                                                            this.setState({
                                                                itemSelectInputEducation: _Educations[index],
                                                                typeEducation: value,
                                                                Education: itemInput,
                                                            });
                                                        }}
                                                        // error={this.state.errorSelectInput}

                                                        //requestServerRetry={container.getServerTypeEducation}
                                                        //  requestServer={this.state.TypeBuildingList.length > 0 ? null : container.getServerTypeEducation}
                                                        // loading={this.state.isLoadingSelectInput}
                                                        value={this.state.typeEducation ? this.state.typeEducation : i18n.t('constant.SelectItem')}
                                                        //index={building.index}
                                                        itemSelectInput={this.state.Education}
                                                        //  value={"ghjghhg"}
                                                        text={i18n.t('constant.Education')}
                                                        // options={options}
                                                        options={_Educations}
                                                        styleRoot={{width: '99%'}}

                                                    />
                                                    {/*       <HMTextInputEfects
                                        onRef={scroll => container["inputEducation"] = scroll}

                                        refName={"Education"}

                                        type={"CostumeFumi"}
                                        value={this.state.Education}

                                        label={i18n.t('constant.Education')}
                                        onChangeText={text => this.setState({
                                            Education: text
                                        })}
                                        iconClass={"FontAwesomeIcon"}
                                        iconName={'phone'}
                                        //   keyboardType={'number-pad'}
                                        // _scroll={this._scroll}

                                        // secureTextEntry={true}
                                        onSubmitEditing={() => this._focusNextField("inputNationalCode")}
                                        containerStyle={{}}
                                        containerInputStyle={{
                                            borderWidth: moderateScale(1),

                                            borderRadius: moderateScale(10),
                                            // overflow: 'hidden',
                                            marginVertical: moderateScale(4)
                                        }}
                                        border={true}

                                    />*/}
                                                </View>

                                            </View>
                                            <View style={{flexDirection: 'row', width: '96%', alignSelf: 'center'}}>

                                                <View style={{flex: .5}}>
                                                    <HMTextInputEfects
                                                        onRef={scroll => container['inputNationalCode'] = scroll}

                                                        refName={'NationalCode'}

                                                        type={'CostumeFumi'}
                                                        value={this.state.NationalCode}

                                                        label={i18n.t('constant.NationalCode')}
                                                        onChangeText={text => this.setState({
                                                            NationalCode: text,
                                                        })}
                                                        iconClass={'FontAwesomeIcon'}
                                                        iconName={'phone'}
                                                        keyboardType={'number-pad'}
                                                        // _scroll={this._scroll}

                                                        // secureTextEntry={true}
                                                        onSubmitEditing={() => this._focusNextField('inputJob')}
                                                        containerStyle={{width: '99%'}}
                                                        containerInputStyle={{
                                                            borderWidth: moderateScale(1),

                                                            borderRadius: moderateScale(10),
                                                            // overflow: 'hidden',
                                                            marginVertical: moderateScale(4),
                                                        }}
                                                        border={true}

                                                    />
                                                </View>
                                                <View style={{flex: .5}}>
                                                    <HMTextInputEfects
                                                        onRef={scroll => container['inputJob'] = scroll}

                                                        refName={'Job'}

                                                        type={'CostumeFumi'}
                                                        value={this.state.Job}

                                                        label={i18n.t('constant.Job')}
                                                        onChangeText={text => this.setState({
                                                            Job: text,
                                                        })}
                                                        iconClass={'FontAwesomeIcon'}
                                                        iconName={'phone'}
                                                        // keyboardType={'number-pad'}
                                                        // _scroll={this._scroll}

                                                        // secureTextEntry={true}
                                                        onSubmitEditing={() => this._focusNextField('inputTypeInjury')}

                                                        containerStyle={{width: '99%'}}
                                                        containerInputStyle={{
                                                            borderWidth: moderateScale(1),

                                                            borderRadius: moderateScale(10),
                                                            // overflow: 'hidden',
                                                            marginVertical: moderateScale(4),
                                                        }}
                                                        border={true}

                                                    />
                                                </View>

                                            </View>

                                            <View
                                                style={{
                                                    // flexDirection: 'row',
                                                    width: '96%',
                                                    alignSelf: 'center',
                                                    //  alignItems: 'center',
                                                    marginVertical: moderateScale(6),
                                                }}>
                                                <HMTextView
                                                    //  numberOfLines={1}
                                                    // type={'bold'}
                                                    text={i18n.t('constant.Gender') + ' : '}
                                                    // text={"در دو هفته اخیر با چند نفر در ارتباط بودید؟"}
                                                    style={{
                                                        //marginTop: moderateScale(18),
                                                        marginHorizontal: moderateScale(6),
                                                        color: Colors.blackLight,
                                                        // marginEnd: moderateScale(10),
                                                        fontSize: moderateScale(14),
                                                        textAlign: 'center',
                                                        //  marginHorizontal: moderateScale(8)

                                                    }}/>


                                                <HMListCheckBox
                                                    data={{
                                                        list: [
                                                            {id: 1, name: i18n.t('constant.Man')},
                                                            {id: 0, name: i18n.t('constant.Woman')},

                                                        ],
                                                        indexSelect: this.state['indexSelectCheckBoxGender'],
                                                        name: 'Gender',

                                                    }}
                                                    onPress={this.onPressSelectCheckBox
                                                    }

                                                />
                                            </View>
                                        </View>

                                }


                                <View
                                    style={{
                                        // flexDirection: 'row',
                                        width: '96%',
                                        alignSelf: 'center',
                                        //  alignItems: 'center',
                                        marginVertical: moderateScale(6),
                                    }}>
                                    <HMTextView
                                        //  numberOfLines={1}
                                        // type={'bold'}
                                        text={i18n.t('constant.type') + ' : '}
                                        // text={"در دو هفته اخیر با چند نفر در ارتباط بودید؟"}
                                        style={{
                                            //marginTop: moderateScale(18),
                                            marginHorizontal: moderateScale(6),
                                            color: Colors.blackLight,
                                            // marginEnd: moderateScale(10),
                                            fontSize: moderateScale(14),
                                            textAlign: 'center',
                                            //  marginHorizontal: moderateScale(8)

                                        }}/>


                                    <HMListCheckBox
                                        data={{
                                            list: [
                                                {id: 0, name: i18n.t('constant.Injury')},
                                                {id: 1, name: i18n.t('constant.Death')},

                                            ],

                                            indexSelect: this.state['indexSelectCheckBoxHealthType'],
                                            name: 'HealthType',

                                        }}
                                        onPress={this.onPressSelectCheckBox
                                        }

                                    />
                                </View>
                                <View style={{
                                    width: '96%',
                                    alignSelf: 'center',
                                }}>
                                    <HMTextInputEfects
                                        onRef={scroll => container['inputTypeInjury'] = scroll}

                                        refName={'TypeInjury'}

                                        type={'CostumeFumi'}
                                        value={this.state.TypeInjury}

                                        label={i18n.t('constant.TypeInjury')}
                                        onChangeText={text => this.setState({
                                            TypeInjury: text,
                                        })}
                                        iconClass={'FontAwesomeIcon'}
                                        iconName={'phone'}
                                        // keyboardType={'number-pad'}
                                        // _scroll={this._scroll}

                                        // secureTextEntry={true}
                                        onSubmitEditing={() => this._focusNextField('inputPlaceDispatchInjured')}

                                        containerStyle={{width: '99.8%'}}
                                        containerInputStyle={{
                                            borderWidth: moderateScale(1),

                                            borderRadius: moderateScale(10),
                                            // overflow: 'hidden',
                                            marginVertical: moderateScale(4),
                                        }}
                                        border={true}

                                    />
                                </View>
                                <View style={{
                                    width: '96%',
                                    alignSelf: 'center',
                                }}>
                                    <HMTextInputEfects
                                        onRef={scroll => container['inputPlaceDispatchInjured'] = scroll}

                                        refName={'PlaceDispatchInjured'}

                                        type={'CostumeFumi'}
                                        value={this.state.PlaceDispatchInjured}

                                        label={i18n.t('constant.PlaceDispatchInjured')}
                                        onChangeText={text => this.setState({
                                            PlaceDispatchInjured: text,
                                        })}
                                        iconClass={'FontAwesomeIcon'}
                                        iconName={'phone'}
                                        // keyboardType={'number-pad'}
                                        // _scroll={this._scroll}

                                        // secureTextEntry={true}
                                        onSubmitEditing={() => {
                                        }}

                                        containerStyle={{width: '99.8%'}}
                                        containerInputStyle={{
                                            borderWidth: moderateScale(1),

                                            borderRadius: moderateScale(10),
                                            // overflow: 'hidden',
                                            marginVertical: moderateScale(4),
                                        }}
                                        border={true}

                                    />
                                </View>
                                <View style={{flexDirection: 'row', width: '96%', alignSelf: 'center'}}>


                                </View>
                                {/*<TouchableOpacity*/}
                                {/*onPress={() => {*/}
                                {/*// this.refs['viewPager'].setPage(this.state.currentPage - 1);*/}
                                {/*//this.refs['viewPager'].setPage(this.state.currentPage - 1);*/}
                                {/*//    this.setState({selectedService: "44"})*/}
                                {/*//  this.goBack();*/}
                                {/*this.setServerRequest()*/}
                                {/*}}*/}
                                {/*style={{*/}
                                {/*width: '92%',*/}
                                {/*height: moderateScale(42),*/}
                                {/*alignSelf: 'center',*/}
                                {/*alignItems: 'center',*/}
                                {/*justifyContent: 'center',*/}
                                {/*backgroundColor: Colors.colorPrimary,*/}
                                {/*borderRadius: moderateScale(6),*/}
                                {/*marginTop: moderateScale(10),*/}
                                {/*marginBottom: moderateScale(4),*/}

                                {/*}}>*/}

                                {/*<HMTextView*/}
                                {/*//  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}*/}
                                {/*text={i18n.t('constant.Back')} type={"bold"}*/}
                                {/*style={{*/}
                                {/*fontSize: moderateScale(13),*/}
                                {/*marginVertical: moderateScale(6),*/}
                                {/*marginHorizontal: moderateScale(4),*/}
                                {/*color: Colors.white*/}
                                {/*}}/>*/}
                                {/*</TouchableOpacity>*/}
                                <TouchableOpacity
                                    onPress={() => {
                                        this.setState({
                                            showListModal: true,
                                        });
                                    }}
                                    style={{position: 'absolute', top: 0, right: 0}}>
                                    <HMIcon name={'ios-close-circle-outline'} style={{
                                        color: Colors.colorDarkText,
                                        fontSize: moderateScale(24),
                                        padding: moderateScale(4),
                                        alignSelf: 'center',
                                    }}/>
                                </TouchableOpacity>
                            </View>

                    }

                </View>;


            case 7 :
                return <View style={{flex: 1}}>
                    <View
                        style={{
                            // flexDirection: 'row',
                            width: '96%',
                            alignSelf: 'center',
                            //  alignItems: 'center',
                            marginVertical: moderateScale(6),
                        }}>
                        <HMTextView
                            //  numberOfLines={1}
                            // type={'bold'}
                            text={'نوع صدمه' + ' : '}
                            // text={"در دو هفته اخیر با چند نفر در ارتباط بودید؟"}
                            style={{
                                //marginTop: moderateScale(18),
                                marginHorizontal: moderateScale(6),
                                color: Colors.blackLight,
                                // marginEnd: moderateScale(10),
                                fontSize: moderateScale(14),
                                textAlign: 'center',
                                //  marginHorizontal: moderateScale(8)

                            }}/>


                        <HMListCheckBox
                            data={{
                                list: [
                                    {id: 0, name: 'عمدی'},
                                    {id: 1, name: 'غیر عمدی'},

                                ],

                                indexSelect: this.state['indexSelectCheckBoxInjuryType'],
                                name: 'InjuryType',

                            }}
                            onPress={this.onPressSelectCheckBox
                            }

                        />
                    </View>
                    <HMTextInputEfects
                        onRef={scroll => container['inputOtherIncidentsByName'] = scroll}

                        refName={'OtherIncidentsByName'}

                        type={'CostumeFumi'}
                        value={this.state.OtherIncidentsByName}

                        label={i18n.t('constant.OtherIncidentsByName')}
                        onChangeText={text => this.setState({
                            OtherIncidentsByName: text,
                        })}
                        iconClass={'FontAwesomeIcon'}
                        iconName={'phone'}
                        //keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => this._focusNextField('inputExplainCausesOfAccident')}
                        containerStyle={{width: '99.8%'}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(1),
                        }}
                        border={true}

                    />


                    <HMTextInputEfects
                        onRef={scroll => container['inputExplainCausesOfAccident'] = scroll}

                        refName={'ExplainCausesOfAccident'}

                        type={'CostumeFumi'}
                        value={this.state.ExplainCausesOfAccident}

                        label={i18n.t('constant.ExplainCausesOfAccident')}
                        onChangeText={text => this.setState({
                            ExplainCausesOfAccident: text,
                        })}
                        iconClass={'FontAwesomeIcon'}
                        iconName={'phone'}
                        //keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => this._focusNextField('inputObjectiveObservationsUponArrival')}
                        containerStyle={{width: '99.8%'}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(1),
                        }}
                        border={true}

                    />


                    <HMTextInputEfects
                        onRef={scroll => container['inputObjectiveObservationsUponArrival'] = scroll}

                        refName={'ObjectiveObservationsUponArrival'}

                        type={'CostumeFumi'}
                        value={this.state.ObjectiveObservationsUponArrival}

                        label={i18n.t('constant.ObjectiveObservationsUponArrival')}
                        onChangeText={text => this.setState({
                            ObjectiveObservationsUponArrival: text,
                        })}
                        iconClass={'FontAwesomeIcon'}
                        iconName={'phone'}
                        //keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => this._focusNextField('inputExplainInitialStepsTaken')}
                        containerStyle={{width: '99.8%'}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(1),
                        }}
                        border={true}

                    />


                    <HMTextInputEfects
                        onRef={scroll => container['inputExplainInitialStepsTaken'] = scroll}

                        refName={'ExplainInitialStepsTaken'}

                        type={'CostumeFumi'}
                        value={this.state.ExplainInitialStepsTaken}

                        label={i18n.t('constant.ExplainInitialStepsTaken')}
                        onChangeText={text => this.setState({
                            ExplainInitialStepsTaken: text,
                        })}
                        iconClass={'FontAwesomeIcon'}
                        iconName={'phone'}
                        //keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => this._focusNextField('inputDescriptionOfOperationsOfDispatchOfficersAndEquipment')}
                        containerStyle={{width: '99.8%'}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(1),
                        }}
                        border={true}

                    />


                    <HMTextInputEfects
                        onRef={scroll => container['inputDescriptionOfOperationsOfDispatchOfficersAndEquipment'] = scroll}

                        refName={'DescriptionOfOperationsOfDispatchOfficersAndEquipment'}

                        type={'CostumeFumi'}
                        value={this.state.DescriptionOfOperationsOfDispatchOfficersAndEquipment}

                        label={i18n.t('constant.DescriptionOfOperationsOfDispatchOfficersAndEquipment')}
                        onChangeText={text => this.setState({
                            DescriptionOfOperationsOfDispatchOfficersAndEquipment: text,
                        })}
                        iconClass={'FontAwesomeIcon'}
                        iconName={'phone'}
                        //keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => this._focusNextField('inputDescriptionProblemsDuringMission')}
                        containerStyle={{width: '99.8%'}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(1),
                        }}
                        border={true}

                    />


                    <HMTextInputEfects
                        onRef={scroll => container['inputDescriptionProblemsDuringMission'] = scroll}

                        refName={'DescriptionProblemsDuringMission'}

                        type={'CostumeFumi'}
                        value={this.state.DescriptionProblemsDuringMission}

                        label={i18n.t('constant.DescriptionProblemsDuringMission')}
                        onChangeText={text => this.setState({
                            DescriptionProblemsDuringMission: text,
                        })}
                        iconClass={'FontAwesomeIcon'}
                        iconName={'phone'}
                        //keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => this._focusNextField('inputEquipmentAndSafetyEquipmentSite')}
                        containerStyle={{width: '99.8%'}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(1),
                        }}
                        border={true}

                    />


                    <HMTextInputEfects
                        onRef={scroll => container['inputEquipmentAndSafetyEquipmentSite'] = scroll}

                        refName={'EquipmentAndSafetyEquipmentSite'}

                        type={'CostumeFumi'}
                        value={this.state.EquipmentAndSafetyEquipmentSite}

                        label={i18n.t('constant.EquipmentAndSafetyEquipmentSite')}
                        onChangeText={text => this.setState({
                            EquipmentAndSafetyEquipmentSite: text,
                        })}
                        iconClass={'FontAwesomeIcon'}
                        iconName={'phone'}
                        //keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => this._focusNextField('inputDescriptionDamageOrganizationVehiclesAndEquipment')}
                        containerStyle={{width: '99.8%'}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(1),
                        }}
                        border={true}

                    />


                    <HMTextInputEfects
                        onRef={scroll => container['inputDescriptionDamageOrganizationVehiclesAndEquipment'] = scroll}

                        refName={'DescriptionDamageOrganizationVehiclesAndEquipment'}

                        type={'CostumeFumi'}
                        value={this.state.DescriptionDamageOrganizationVehiclesAndEquipment}

                        label={i18n.t('constant.DescriptionDamageOrganizationVehiclesAndEquipment')}
                        onChangeText={text => this.setState({
                            DescriptionDamageOrganizationVehiclesAndEquipment: text,
                        })}
                        iconClass={'FontAwesomeIcon'}
                        iconName={'phone'}
                        //keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => this._focusNextField('inputCollectCostsDamagesOrganizationVehiclesAndEquipment')}
                        containerStyle={{width: '99.8%'}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(1),
                        }}
                        border={true}

                    />

                    <HMTextInputEfects
                        onRef={scroll => container['inputCollectCostsDamagesOrganizationVehiclesAndEquipment'] = scroll}

                        refName={'CollectCostsDamagesOrganizationVehiclesAndEquipment'}

                        type={'CostumeFumi'}
                        value={this.state.CollectCostsDamagesOrganizationVehiclesAndEquipment}

                        label={i18n.t('constant.CollectCostsDamagesOrganizationVehiclesAndEquipment')}
                        onChangeText={text => this.setState({
                            CollectCostsDamagesOrganizationVehiclesAndEquipment: text,
                        })}
                        iconClass={'FontAwesomeIcon'}
                        iconName={'phone'}
                        keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => this._focusNextField('inputDescriptionDamageAccidentSite')}
                        containerStyle={{width: '99.8%'}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(1),
                        }}
                        border={true}

                    />


                    <HMTextInputEfects
                        onRef={scroll => container['inputDescriptionDamageAccidentSite'] = scroll}

                        refName={'DescriptionDamageAccidentSite'}

                        type={'CostumeFumi'}
                        value={this.state.DescriptionDamageAccidentSite}

                        label={i18n.t('constant.DescriptionDamageAccidentSite')}
                        onChangeText={text => this.setState({
                            DescriptionDamageAccidentSite: text,
                        })}
                        iconClass={'FontAwesomeIcon'}
                        iconName={'phone'}
                        //keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => this._focusNextField('inputFinalTheoryAndSafetyTips')}
                        containerStyle={{width: '99.8%'}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(1),
                        }}
                        border={true}

                    />


                    <HMTextInputEfects
                        onRef={scroll => container['inputFinalTheoryAndSafetyTips'] = scroll}

                        refName={'FinalTheoryAndSafetyTips'}

                        type={'CostumeFumi'}
                        value={this.state.FinalTheoryAndSafetyTips}

                        label={i18n.t('constant.FinalTheoryAndSafetyTips')}
                        onChangeText={text => this.setState({
                            FinalTheoryAndSafetyTips: text,
                        })}
                        iconClass={'FontAwesomeIcon'}
                        iconName={'phone'}
                        //keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => this._focusNextField('inputTheoryDepartmentEducationAndPreventionPhysicalConditionPlace')}
                        containerStyle={{width: '99.8%'}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(1),
                        }}
                        border={true}

                    />


                    <HMTextInputEfects
                        onRef={scroll => container['inputTheoryDepartmentEducationAndPreventionPhysicalConditionPlace'] = scroll}

                        refName={'TheoryDepartmentEducationAndPreventionPhysicalConditionPlace'}

                        type={'CostumeFumi'}
                        value={this.state.TheoryDepartmentEducationAndPreventionPhysicalConditionPlace}

                        label={i18n.t('constant.TheoryDepartmentEducationAndPreventionPhysicalConditionPlace')}
                        onChangeText={text => this.setState({
                            TheoryDepartmentEducationAndPreventionPhysicalConditionPlace: text,
                        })}
                        iconClass={'FontAwesomeIcon'}
                        iconName={'phone'}
                        //keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => this._focusNextField('inputAttendanceAndCooperationOtherStationsCentersOrganizations')}
                        containerStyle={{width: '99.8%'}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(1),
                        }}
                        border={true}

                    />


                    <HMTextInputEfects
                        onRef={scroll => container['inputAttendanceAndCooperationOtherStationsCentersOrganizations'] = scroll}

                        refName={'AttendanceAndCooperationOtherStationsCentersOrganizations'}

                        type={'CostumeFumi'}
                        value={this.state.AttendanceAndCooperationOtherStationsCentersOrganizations}

                        label={i18n.t('constant.AttendanceAndCooperationOtherStationsCentersOrganizations')}
                        onChangeText={text => this.setState({
                            AttendanceAndCooperationOtherStationsCentersOrganizations: text,
                        })}
                        iconClass={'FontAwesomeIcon'}
                        iconName={'phone'}
                        //keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => {
                        }}
                        containerStyle={{width: '99.8%'}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(1),
                        }}
                        border={true}

                    />


                </View>;

            case 8 :
                return <View>
                    {
                        this.state.showListModal ?
                            <View>
                                <EmptyView empty={this.state.EquipmentItems && this.state.EquipmentItems.length === 0}/>

                                <FlatList
                                    data={this.state.EquipmentItems}
                                    // data={[
                                    //     {
                                    //         id: 1,
                                    //         date: "1399/03/12",
                                    //         firstName: "احمد",
                                    //         lastName: "خلیلی",
                                    //         age: "28",
                                    //         education: "کارشناسی",
                                    //         national_code: "0520525264",
                                    //         job: "برنامه نویس",
                                    //         type: "غیر مامور",
                                    //         gender: "آقا",
                                    //         typeHealth: "مصدومیت",
                                    //         desc: "پای مصدوم بشدت آسیب دیده",
                                    //         place: "اراک خ سی متری فوتبال کوچه شهید کریم پور بالاتر از پارک فجر للللللللللل اتیلسبالسایبلتا اسیلبالالسیالیاساتیسلایل",
                                    //     }, {
                                    //         id: 1,
                                    //         date: "1399/03/12",
                                    //         firstName: "احمد",
                                    //         lastName: "خلیلی",
                                    //         age: "28",
                                    //         education: "کارشناسی",
                                    //         national_code: "0520525264",
                                    //         job: "برنامه نویس",
                                    //
                                    //         type: "غیر مامور",
                                    //         gender: "آقا",
                                    //         typeHealth: "مصدومیت",
                                    //         desc: "پای مصدوم بشدت آسیب دیده",
                                    //         place: "اراک خ سی متری فوتبال کوچه شهید کریم پور بالاتر از پارک فجر",
                                    //     }, {
                                    //         id: 1,
                                    //         date: "1399/03/12",
                                    //         firstName: "احمد",
                                    //         lastName: "خلیلی",
                                    //         age: "28",
                                    //         education: "کارشناسی",
                                    //         national_code: "0520525264",
                                    //         job: "برنامه نویس",
                                    //
                                    //         type: "غیر مامور",
                                    //         gender: "آقا",
                                    //         typeHealth: "مصدومیت",
                                    //         desc: "پای مصدوم بشدت آسیب دیده",
                                    //         place: "اراک خ سی متری فوتبال کوچه شهید کریم پور بالاتر از پارک فجر",
                                    //     }, {
                                    //         id: 1,
                                    //         date: "1399/03/12",
                                    //         firstName: "احمد",
                                    //         lastName: "خلیلی",
                                    //         age: "28",
                                    //         education: "کارشناسی",
                                    //         national_code: "0520525264",
                                    //         job: "برنامه نویس",
                                    //
                                    //         type: "غیر مامور",
                                    //         gender: "آقا",
                                    //         typeHealth: "مصدومیت",
                                    //         desc: "پای مصدوم بشدت آسیب دیده",
                                    //         place: "اراک خ سی متری فوتبال کوچه شهید کریم پور بالاتر از پارک فجر",
                                    //     }, {
                                    //         id: 1,
                                    //         date: "1399/03/12",
                                    //         firstName: "احمد",
                                    //         lastName: "خلیلی",
                                    //         age: "28",
                                    //         education: "کارشناسی",
                                    //         national_code: "0520525264",
                                    //         job: "برنامه نویس",
                                    //
                                    //         type: "غیر مامور",
                                    //         gender: "آقا",
                                    //         typeHealth: "مصدومیت",
                                    //         desc: "پای مصدوم بشدت آسیب دیده",
                                    //         place: "اراک خ سی متری فوتبال کوچه شهید کریم پور بالاتر از پارک فجر",
                                    //     },
                                    //
                                    // ]}
                                    renderItem={({item, index}) => {
                                        return <View
                                            style={{
                                                flex: 1,
                                                overflow: 'hidden',
                                                //height:  moderateScale(100),
                                                // padding: moderateScale(4),
                                                marginVertical: moderateScale(5),
                                                borderWidth: moderateScale(1),
                                                borderRadius: moderateScale(2),
                                                borderColor: '#ddd',
                                                borderBottomWidth: 0,
                                                shadowColor: '#000',
                                                shadowOffset: {width: 0, height: moderateScale(.7)},
                                                shadowOpacity: 0.6,
                                                shadowRadius: moderateScale(2),
                                                elevation: moderateScale(1),
                                                // marginLeft: moderateScale(1),
                                                // marginRight: moderateScale(1),
                                                // marginTop: moderateScale(1),
                                                // marginBottom: moderateScale(1),
                                                backgroundColor: Colors.light3,
                                            }}>

                                            <View style={{padding: moderateScale(6)}}>


                                                <View style={{flexDirection: 'row', flex: 1}}>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={'نوع وسیله' + ' : '}
                                                        type={'bold'}
                                                        style={{
                                                            // textAlign: "center",
                                                            color: Colors.blackLight,
                                                            fontSize: moderateScale(11),


                                                        }}/>

                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={item.TypeTools}
                                                        type={'bold'}
                                                        style={{
                                                            //textAlign: "center",
                                                            color: Colors.colorDark,
                                                            fontSize: moderateScale(10),


                                                        }}
                                                        styleRoot={{flex: 1, flexWrap: 'wrap'}}
                                                    />
                                                </View>
                                                <View style={{flexDirection: 'row'}}>
                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={'مقدار مصرفی' + ' : '}
                                                        type={'bold'}
                                                        style={{
                                                            textAlign: 'center',
                                                            color: Colors.blackLight,
                                                            fontSize: moderateScale(11),


                                                        }}

                                                    />

                                                    <HMTextView
                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                        text={item.Value}
                                                        type={'bold'}
                                                        style={{
                                                            textAlign: 'center',
                                                            color: Colors.colorDark,
                                                            fontSize: moderateScale(10),


                                                        }}
                                                        styleRoot={{flex: 1, flexWrap: 'wrap'}}

                                                    />
                                                </View>

                                            </View>
                                        </View>;
                                    }}
                                    //renderItem={this.renderItem}
                                    keyExtractor={(item, index) => index.toString()}
                                    ListEmptyComponent={() =>
                                        null}
                                    // //  ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                    // ListFooterComponent={this.renderFooter.bind(this)}
                                    // refreshing={this.props.showRefresh}
                                    // onRefresh={this.handleRefresh.bind(this)}
                                    // onEndReached={this.handleLoadMore.bind(this)}
                                    // onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                />


                            </View>
                            :
                            <View>

                                <HMSelectInput
                                    styleRoot={{marginTop: moderateScale(14)}}
                                    onValueChange={(value, itemInput) => {
                                        this.setState({
                                            DeviceType: value,
                                            Device: itemInput,
                                        });
                                    }}
                                    //   requestServer={this.state.TypeBuildingList.length > 0 ? null : this.getServerEquipmentItem}
                                    requestServerRetry={container.getServerEquipmentItem}

                                    requestServer={this.state.EquipmentItemList.length > 0 ? null : container.getServerEquipmentItem}
                                    //value={this.state.DeviceType >= 0 ? "ghjhj": i18n.t('constant.SelectItem')}
                                    value={this.state.DeviceType ? this.state.DeviceType : i18n.t('constant.SelectItem')}
                                    // index={building.index}
                                    itemSelectInput={this.state.Device}

                                    error={this.state.errorSelectInput}
                                    loading={this.state.isLoadingSelectInput}
                                    text={i18n.t('constant.DeviceType')}
                                    options={this.state.EquipmentItemList}/>

                                <HMTextInputEfects
                                    onRef={scroll => container['inputNumberAmountConsumed'] = scroll}

                                    refName={'NumberAmountConsumed'}

                                    type={'CostumeFumi'}
                                    value={this.state.NumberAmountConsumed}

                                    label={i18n.t('constant.NumberAmountConsumed')}
                                    onChangeText={text => this.setState({
                                        NumberAmountConsumed: text,
                                    })}
                                    iconClass={'FontAwesomeIcon'}
                                    iconName={'phone'}
                                    keyboardType={'number-pad'}
                                    // _scroll={this._scroll}

                                    // secureTextEntry={true}
                                    onSubmitEditing={() => {
                                    }}
                                    containerStyle={{width: '99.8%'}}
                                    containerInputStyle={{
                                        borderWidth: moderateScale(1),

                                        borderRadius: moderateScale(10),
                                        // overflow: 'hidden',
                                        marginVertical: moderateScale(4),
                                    }}
                                    border={true}

                                />
                                <TouchableOpacity
                                    onPress={() => {
                                        this.setState({
                                            showListModal: true,
                                        });
                                    }}
                                    style={{position: 'absolute', top: 0, right: 0}}>
                                    <HMIcon name="ios-close-circle-outline" style={{
                                        color: Colors.colorDarkText,
                                        fontSize: moderateScale(24),
                                        padding: moderateScale(4),
                                        alignSelf: 'center',
                                    }}/>
                                </TouchableOpacity>
                            </View>
                    }
                </View>;
            case 10 :
                return <View style={{
                    flex: 1,
                    //  width: "100%", height: "100%",
                    // position: "absolute",
                    // top: 0,
                    // bottom: 0,
                    // left: 0,
                    // right: 0,
                    //  backgroundColor: "#ccee27",

                }}>
                    <WebViewScreen
                        external_url={global._viewUrl + `?Rid=${itemParams.RequestID}&Token=${this.props.token}`}
                        noShowBack={true} noScalesPageToFit={true}/>
                    <HMTextInputEfects
                        onRef={scroll => container['inputDescriptionConfirmOperation'] = scroll}

                        refName={'DescriptionConfirmOperation'}

                        type={'CostumeFumi'}
                        value={this.state.DescriptionConfirmOperation}

                        label={i18n.t('constant.Description')}
                        onChangeText={text => this.setState({
                            DescriptionConfirmOperation: text,
                        })}
                        iconClass={'FontAwesomeIcon'}
                        iconName={'phone'}
                        //keyboardType={'number-pad'}
                        // _scroll={this._scroll}

                        // secureTextEntry={true}
                        onSubmitEditing={() => {
                        }}
                        containerStyle={{width: '99.8%'}}
                        containerInputStyle={{
                            borderWidth: moderateScale(1),

                            borderRadius: moderateScale(10),
                            // overflow: 'hidden',
                            marginVertical: moderateScale(4),
                        }}
                        border={true}

                    />
                </View>;


        }
    }

    onPressSelectCheckBox(item, name, check) {
        container.setState({
                ['indexSelectCheckBox' + name]: check ? null : item.id,
                // ['indexSelectCheckBox' + name]: item.id
            },
            () => {
            });
    }

    renderModalMenu(data) {
        let {setIndex, routes, index, slider1ActiveSlide} = this.state;
        let CustomeView = this.state.typeMenu !== 10 ? ScrollView : View;

        const options = [
            {value: 100, label: '100'},
            {value: 1, label: '1'},
            {value: 2, label: '2'},
            {value: 3, label: '3'},
            {value: 4, label: '4'},
            {value: 5, label: '5'},
            {value: 5, label: '5'},
            {value: 5, label: '5'},
            {value: 5, label: '5'},
            {value: 5, label: '5'},
            {value: 5, label: '5'},
            {value: 5, label: '5'},
            {value: 5, label: '5'},
            {value: 5, label: '5'},
            {value: 5, label: '5'},
            {value: 5, label: '5'},
            {value: 5, label: '5'},
            {value: 5, label: '5'},
            {value: 5, label: '5'},
            {value: 5, label: '5'},
            {value: 5, label: '5'},
            {value: 5, label: '10'},
        ];
        return (
            <HMModal
                isVisible={this.state.visibleModalMenu === 'selectMenu'}
                backdropColor={Colors.gray}
                backdropOpacity={0.8}
                animationIn="zoomInDown"
                animationOut="zoomOutUp"
                animationInTiming={600}
                animationOutTiming={600}
                backdropTransitionInTiming={600}
                backdropTransitionOutTiming={600}
                //style={{height: '60%'}}
                onBackdropPress={() => this.hiddenModal('Menu')}
                onBackButtonPress={() => this.hiddenModal('Menu')}
                // style={{zIndex: 0}}
                statusBarTranslucent

            >

                <View style={{

                    width: '99%',
                    height: '96%',

                    // position: 'absolute',
                    //    bottom: 0,

                    marginVertical: moderateScale(10),
                    minHeight: '60%',
                    padding: moderateScale(8),
                    backgroundColor: Colors.white,
                    border: moderateScale(4),
                }}>

                    <CustomeView

                        style={{
                            width: '100%',
                            height: '94%',

                        }}
                        ref={scroll => container._scroll = scroll}
                        keyboardShouldPersistTaps="handled"
                    >

                        {
                            this.state.isLoadingModal ?
                                <HMLoading style={[
                                    //     this.state.typeMenu == 7 ? {
                                    //     backgroundColor: 'rgba(0,0,0,0.7)',
                                    //     position: "absolute",
                                    //     top: 0,
                                    //     bottom: 0,
                                    //     left: 0,
                                    //     right: 0,
                                    //     zIndex: 100,
                                    // } : {},

                                    {justifyContent: 'center', alignItems: 'center'}]}/>
                                : null
                        }
                        {
                            this.renderChildModalMenu(options)
                        }

                    </CustomeView>
                    {
                        this.state.errorModal ?
                            <DialogConnectionCustomize
                                again
                                onPress={() => {
                                    this.setState({errorModal: false});
                                }}
                            />
                            :
                            null
                    }
                    {
                        this.state.showListModal ?
                            null
                            :
                            <TouchableOpacity
                                onPress={() => {
                                    // this.refs['viewPager'].setPage(this.state.currentPage - 1);
                                    //this.refs['viewPager'].setPage(this.state.currentPage - 1);
                                    //    this.setState({selectedService: "44"})
                                    //  this.goBack();
                                    this.setServerRequest();
                                }}
                                style={{
                                    width: '94%',
                                    height: moderateScale(42),
                                    alignSelf: 'center',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: Colors.colorSecondPrimary,
                                    borderRadius: moderateScale(6),
                                    marginTop: moderateScale(10),
                                    marginBottom: moderateScale(4),

                                }}>

                                <HMTextView
                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                    text={this.state.typeMenu === 10 ? 'تایید عملیات' : i18n.t('constant.Registration')}
                                    type={'bold'}
                                    style={{
                                        fontSize: moderateScale(13),
                                        marginVertical: moderateScale(6),
                                        marginHorizontal: moderateScale(4),
                                        color: Colors.white,
                                    }}/>
                            </TouchableOpacity>
                    }
                    {
                        !this.state.showListModal ?
                            null
                            :
                            <TouchableOpacity
                                onPress={() => {
                                    if (this.state.idMenu == 4) {
                                        this.setState({
                                            visibleModalMenu: '',
                                        });
                                        NavigationService.navigateParams('SubmitRequestOperationFireScreen', {item: this.props.route.params.item});
                                    }
                                    else {
                                        this.setState({
                                            showListModal: false,


                                            // OwnerName: null,
                                            // TenantName: null,
                                            // NumberOfFloors: null,
                                            // NumberOfUnitsPerFloor: null,
                                            // typeBuilding: null,
                                            // TypeBuildingResult: null,
                                            //
                                            // OtherIncidentsByName: null,
                                            // ExplainCausesOfAccident: null,
                                            // ObjectiveObservationsUponArrival: null,
                                            // ExplainInitialStepsTaken: null,
                                            // DescriptionOfOperationsOfDispatchOfficersAndEquipment: null,
                                            // DescriptionProblemsDuringMission: null,
                                            // EquipmentAndSafetyEquipmentSite: null,
                                            // DescriptionDamageOrganizationVehiclesAndEquipment: null,
                                            // CollectCostsDamagesOrganizationVehiclesAndEquipment: null,
                                            // DescriptionDamageAccidentSite: null,
                                            // FinalTheoryAndSafetyTips: null,
                                            // TheoryDepartmentEducationAndPreventionPhysicalConditionPlace: null,
                                            // AttendanceAndCooperationOtherStationsCentersOrganizations: null,


                                            NumberAmountConsumed: null,


                                            First_name: null,
                                            Last_name: null,
                                            NationalCode: null,
                                            PlaceDispatchInjured: null,
                                            TypeInjury: null,
                                            Age: null,
                                            Job: null,
                                            Education: null,
                                            TaskAgent: null,
                                            AddressAgent: null,
                                            InjuryAgent: null,
                                            DescriptionAgent: null,
                                            EquipmentAgent: null,
                                            indexSelectCheckBoxHealthType: 0,
                                            indexSelectCheckBoxGender: 1,
                                            indexSelectCheckBoxtype: 0,
                                            UserAgent: null,
                                        });
                                    }
                                }}
                                style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    right: 0,
                                    overflow: 'hidden',
                                    width: moderateScale(40),
                                    height: moderateScale(40),
                                    borderRadius: moderateScale(20),
                                    // padding: moderateScale(4),
                                    margin: moderateScale(2),
                                    borderWidth: moderateScale(1),
                                    borderColor: '#ddd',
                                    borderBottomWidth: 0,
                                    shadowColor: '#000',
                                    shadowOffset: {width: 0, height: moderateScale(.7)},
                                    shadowOpacity: 0.6,
                                    shadowRadius: moderateScale(2),
                                    elevation: moderateScale(1),
                                    // marginLeft: moderateScale(1),
                                    // marginRight: moderateScale(1),
                                    // marginTop: moderateScale(1),
                                    // marginBottom: moderateScale(1),
                                    backgroundColor: Colors.colorSecondPrimary,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                <HMIcon name="md-add" style={{
                                    color: Colors.white,
                                    fontSize: moderateScale(28),
                                    //  padding: moderateScale(4),
                                    alignSelf: 'center',
                                }}/>
                            </TouchableOpacity>
                    }
                    {
                        this.state.isLoadingModalSet ?
                            <DialogLoadingCustomize/>
                            : null
                    }


                </View>

            </HMModal>
        );
    }

    setServerRequest() {
        let formData = new FormData();

        switch (this.state.typeMenu) {
            case 5:

                formData.append('_operation', typeExport._Fire);
                formData.append('mode', 'SetMelkDetail');
                formData.append('lang', i18n.locale);
                formData.append('token', store.getState().reducerSplashGetAllData.token);
                formData.append('record', itemParams.RequestID);
                formData.append('typeBuilding', this.state.typeBuilding);
                formData.append('countFloor', this.state.NumberOfFloors);
                formData.append('countUnitOfFloor', this.state.NumberOfUnitsPerFloor);
                formData.append('nameOwner', this.state.OwnerName);
                formData.append('nameTenant', this.state.TenantName);
                formData.append('weather', this.state.AtmosphericConditions);


                this.requestServer(formData, () => {
                    container.changeState();

                }, 'modalSet');
                break;

            case 6:

                formData.append('_operation', typeExport._Fire);
                formData.append('mode', 'AddDamage');
                formData.append('lang', i18n.locale);
                formData.append('token', store.getState().reducerSplashGetAllData.token);
                formData.append('record', itemParams.RequestID);
                formData.append('name', this.state.First_name);
                formData.append('family', this.state.Last_name);
                formData.append('nationalCode', this.state.NationalCode);
                formData.append('placeSend', this.state.PlaceDispatchInjured);
                formData.append('commentDamage', this.state.TypeInjury);
                formData.append('oldDamage', this.state.Age ? JSON.stringify(this.state.Age) : null);
                formData.append('job', this.state.Job);
                formData.append('education', this.state.Education ? JSON.stringify(this.state.Education) : null);

                //Agent
                formData.append('TaskAgent', this.state.TaskAgent);
                formData.append('AddressAgent', this.state.AddressAgent);
                formData.append('InjuryAgent', this.state.InjuryAgent);
                formData.append('DescriptionAgent', this.state.DescriptionAgent);
                formData.append('EquipmentAgent', this.state.EquipmentAgent);

                formData.append('death', this.state.indexSelectCheckBoxHealthType);
                formData.append('male', this.state.indexSelectCheckBoxGender);
                formData.append('typeBody', this.state.indexSelectCheckBoxtype);
                formData.append('UserAgent', this.state.indexSelectCheckBoxtype == 0 ? this.state.UserAgent : null);

                this.requestServer(formData, () => {
                    container.changeState();
                    container.getServerDamages();
                }, 'modalSet', 'selectMenu');
                break;
            case 7:

                formData.append('_operation', typeExport._Fire);
                formData.append('mode', 'AdditionalInformation');
                formData.append('lang', i18n.locale);
                formData.append('token', store.getState().reducerSplashGetAllData.token);
                formData.append('record', itemParams.RequestID);
                formData.append('otherEvent', this.state.OtherIncidentsByName);
                formData.append('reason', this.state.ExplainCausesOfAccident);
                formData.append('firstObserve', this.state.ObjectiveObservationsUponArrival);
                formData.append('firstAction', this.state.ExplainInitialStepsTaken);
                formData.append('commentAction', this.state.DescriptionOfOperationsOfDispatchOfficersAndEquipment);
                formData.append('pereventAction', this.state.DescriptionProblemsDuringMission);
                formData.append('toolsInPosition', this.state.EquipmentAndSafetyEquipmentSite);
                formData.append('damageToTools', this.state.DescriptionDamageOrganizationVehiclesAndEquipment);
                formData.append('priceDamageToTools', this.state.CollectCostsDamagesOrganizationVehiclesAndEquipment);
                formData.append('damageToPosition', this.state.DescriptionDamageAccidentSite);
                formData.append('commentFinal', this.state.FinalTheoryAndSafetyTips);
                formData.append('commentPosition', this.state.TheoryDepartmentEducationAndPreventionPhysicalConditionPlace);
                formData.append('other', this.state.AttendanceAndCooperationOtherStationsCentersOrganizations);
                formData.append('injury', this.state.indexSelectCheckBoxInjuryType);

                this.requestServer(formData, () => {
                    container.setState({visibleModalMenu: null});
                    container.changeState();

                }, 'modalSet');
                break;
            case 8:

                formData.append('_operation', typeExport._Fire);
                formData.append('mode', 'AddEquipment');
                formData.append('lang', i18n.locale);
                formData.append('token', store.getState().reducerSplashGetAllData.token);
                formData.append('record', itemParams.RequestID);
                formData.append('value', this.state.NumberAmountConsumed);


                formData.append('typeTools', this.state.DeviceType);


                this.requestServer(formData, () => {
                    container.changeState();

                    this.getServerEquipmentItem();

                }, 'modalSet', 'selectMenu');
                break;
            case 10:

                formData.append('_operation', typeExport._Fire);
                formData.append('mode', 'SaveInfoRequest');
                formData.append('lang', i18n.locale);
                formData.append('token', store.getState().reducerSplashGetAllData.token);
                formData.append('record', itemParams.RequestID);
                formData.append('description', this.state.DescriptionConfirmOperation);


                this.requestServer(formData, () => {
                    container.changeState();

                    //  this.getServerEquipmentItem();

                }, 'modalSet', 'selectMenu');
                break;
        }
    }

    getServerTypeBuilding(func, fourceRequest) {
        //alert("sdfjhsgd")
        // if (container.state.TypeBuildingList.length < 1 || fourceRequest) {
        if (true) {
            let formData = new FormData();

            formData.append('_operation', typeExport._Fire);
            formData.append('mode', 'GetMelkDetail');
            formData.append('lang', i18n.locale);
            formData.append('token', store.getState().reducerSplashGetAllData.token);
            formData.append('record', itemParams.RequestID);

            container.requestServer(
                formData,
                (item) => {
                    container.setState({
                        visibleModalMenu: 'selectMenu',
                        OwnerName: item.result.Details.NameOwner,
                        TenantName: item.result.Details.NameTenant,
                        NumberOfFloors: item.result.Details.CountFloor,
                        NumberOfUnitsPerFloor: item.result.Details.CountUnitOfFloor,
                        typeBuilding: item.result.Details.TypeBuilding ? parseInt(item.result.Details.TypeBuilding) : -1,
                        TypeBuildingResult: item,
                        // Building: this.getNameBuilding(),
                        TypeBuildingList: item.result && item.result.list && item.result.list.length > 0 ? item.result.list : [],
                    }, () => {
                        func ? func() : null;
                        //alert(item.success)
                    });
                }
                ,
                //'selectInput'
                'modal',
            );
        }
        else {
            container.setState({visibleModalMenu: 'selectMenu'});
        }
    }

    getServerFiles(func) {
        container.setState({showListModal: true});


        let formData = new FormData();

        formData.append('_operation', typeExport._Fire);
        formData.append('mode', 'GetAnswers');
        formData.append('lang', i18n.locale);
        formData.append('token', store.getState().reducerSplashGetAllData.token);
        formData.append('record', itemParams.RequestID);
        // this.setState({
        //     showListModal: true
        // })
        container.requestServer(
            formData,
            (item) => container.setState({
                visibleModalMenu: 'selectMenu',
                FileList: item.result && item.result.list && item.result.list.length > 0 ? item.result.list : [],
            }, () => {
                func ? func() : null;
                //alert(item.success)
            }),
            'modal',
        );

    }

    getServerDamages(func) {
        //  console.log("func", func)
        container.setState({showListModal: true});


        let formData = new FormData();

        formData.append('_operation', typeExport._Fire);
        formData.append('mode', 'GetDamages');
        formData.append('lang', i18n.locale);
        formData.append('token', store.getState().reducerSplashGetAllData.token);
        formData.append('record', itemParams.RequestID);
        // this.setState({
        //     showListModal: true
        // })
        container.requestServer(
            formData,
            (item) => container.setState({
                visibleModalMenu: 'selectMenu',
                DamagesList: item.result && item.result.list && item.result.list.length > 0 ? item.result.list : [],
            }, () => {
                func ? func() : null;
                //alert(item.success)
            }),
            'modal',
        );

    }

    getServerAdditionalInformation(func) {
        container.setState({showListModal: false});

        //   console.log('func', func)
        if (container.state.EquipmentItemList.length < 1) {
            let formData = new FormData();
            formData.append('_operation', typeExport._Fire);
            formData.append('mode', 'GetAdditionalInformation');
            formData.append('lang', i18n.locale);
            formData.append('token', store.getState().reducerSplashGetAllData.token);
            formData.append('record', itemParams.RequestID);

            // formData.append('otherEvent', this.state.OtherIncidentsByName);
            // formData.append('reason', this.state.ExplainCausesOfAccident);
            // formData.append('firstObserve', this.state.ObjectiveObservationsUponArrival);
            // formData.append('firstAction', this.state.ExplainInitialStepsTaken);
            // formData.append('commentAction', this.state.DescriptionOfOperationsOfDispatchOfficersAndEquipment);
            // formData.append('pereventAction', this.state.DescriptionProblemsDuringMission);
            // formData.append('toolsInPosition', this.state.EquipmentAndSafetyEquipmentSite);
            // formData.append('damageToTools', this.state.DescriptionDamageOrganizationVehiclesAndEquipment);
            // formData.append('priceDamageToTools', this.state.CollectCostsDamagesOrganizationVehiclesAndEquipment);
            // formData.append('damageToPosition', this.state.DescriptionDamageAccidentSite);
            // formData.append('commentFinal', this.state.FinalTheoryAndSafetyTips);
            // formData.append('commentPosition', this.state.TheoryDepartmentEducationAndPreventionPhysicalConditionPlace);
            // formData.append('other', this.state.AttendanceAndCooperationOtherStationsCentersOrganizations);
            container.requestServer(
                formData, (item) => {

                    let d = item.result.Details;
                    container.setState({
                        indexSelectCheckBoxInjuryType: d.injury ? d.injury : container.state.indexSelectCheckBoxInjuryType,
                        OtherIncidentsByName: d.otherEvent,
                        ExplainCausesOfAccident: d.reason,
                        ObjectiveObservationsUponArrival: d.firstObserve,
                        ExplainInitialStepsTaken: d.firstAction,
                        DescriptionOfOperationsOfDispatchOfficersAndEquipment: d.commentAction,
                        DescriptionProblemsDuringMission: d.pereventAction,
                        EquipmentAndSafetyEquipmentSite: d.toolsInPosition,
                        DescriptionDamageOrganizationVehiclesAndEquipment: d.damageToTools,
                        CollectCostsDamagesOrganizationVehiclesAndEquipment: d.priceDamageToTools,
                        DescriptionDamageAccidentSite: d.damageToPosition,
                        FinalTheoryAndSafetyTips: d.commentFinal,
                        TheoryDepartmentEducationAndPreventionPhysicalConditionPlace: d.commentPosition,
                        AttendanceAndCooperationOtherStationsCentersOrganizations: d.other,

                        //EquipmentItemList: item.result && item.result.list && item.result.list.length > 0 ? item.result.list : [],
                        visibleModalMenu: 'selectMenu',

                    }, () => {
                        //alert(item.success)
                        func ? func() : null;
                    });
                },
                'modal',
            );
        }
        else {
            container.setState({visibleModalMenu: 'selectMenu'});
        }
    }

    getServerUserAgents(func) {
        //container.setState({showListModal: true})

        //   console.log('func', func)
        //     if (container.state.EquipmentItemList.length < 1) {
        let formData = new FormData();
        formData.append('_operation', typeExport._Fire);
        formData.append('mode', 'GetRequestUserAgents');
        formData.append('lang', i18n.locale);
        formData.append('token', store.getState().reducerSplashGetAllData.token);
        formData.append('record', itemParams.RequestID);


        container.requestServer(
            formData, (item) => container.setState({
                UserAgentList: item.result && item.result.list && item.result.list.length > 0 ? item.result.list : [],
                //  EquipmentItems: item.result && item.result.items && item.result.items.length > 0 ? item.result.items : [],
                visibleModalMenu: 'selectMenu',
            }, () => {
                //alert(item.success)
                func ? func() : null;
            }), 'modal', null, 'UserAgent',
        );
        // }
        // else {
        //     container.setState({visibleModalMenu: "selectMenu",})
        // }
    }

    getServerEquipmentItem(func) {
        container.setState({showListModal: true});

        //   console.log('func', func)
        //     if (container.state.EquipmentItemList.length < 1) {
        let formData = new FormData();
        formData.append('_operation', typeExport._Fire);
        formData.append('mode', 'GetRequestEquipment');
        formData.append('lang', i18n.locale);
        formData.append('token', store.getState().reducerSplashGetAllData.token);
        formData.append('record', itemParams.RequestID);


        container.requestServer(
            formData, (item) => container.setState({
                EquipmentItemList: item.result && item.result.list && item.result.list.length > 0 ? item.result.list : [],
                EquipmentItems: item.result && item.result.items && item.result.items.length > 0 ? item.result.items : [],
                visibleModalMenu: 'selectMenu',
            }, () => {
                //alert(item.success)
                func ? func() : null;
            }), 'modal',
        );
        // }
        // else {
        //     container.setState({visibleModalMenu: "selectMenu",})
        // }
    }

    getServerConfirmOperation(func) {
        container.setState({showListModal: true});

        //   console.log('func', func)
        //     if (container.state.EquipmentItemList.length < 1) {
        let formData = new FormData();
        formData.append('_operation', typeExport._Fire);
        formData.append('mode', 'GetRequestEquipment');
        formData.append('lang', i18n.locale);
        formData.append('token', store.getState().reducerSplashGetAllData.token);
        formData.append('record', itemParams.RequestID);


        container.requestServer(
            formData, (item) => container.setState({
                EquipmentItemList: item.result && item.result.list && item.result.list.length > 0 ? item.result.list : [],
                EquipmentItems: item.result && item.result.items && item.result.items.length > 0 ? item.result.items : [],
                visibleModalMenu: 'selectMenu',
            }, () => {
                //alert(item.success)
                func ? func() : null;
            }), 'modal',
        );
        // }
        // else {
        //     container.setState({visibleModalMenu: "selectMenu",})
        // }
    }

    async saveOfflineTask() {
        let arr = await AsyngStorageClass.getASyng(global.IdCity + 'ListMessageHistoryOperatorFireScreen');

        arr = arr ? arr : [];
        arr.push(this.props.route.params.item);
        await AsyngStorageClass.setAsyng(global.IdCity + 'ListMessageHistoryOperatorFireScreen', arr);

        global.RefreshListOperatorFireApplyScreen = true;
    }

    requestServer(formData, func, type, ShowModal, nameState) {
        let name = nameState ? 'isLoading' + nameState : null;
        let nameError = nameState ? nameState + 'Error' : null;
        let errorModal = null;

        if (!name) {
            errorModal = 'errorModal';

            switch (type) {

                case 'selectInput':
                    name = 'isLoadingSelectInput';

                    break;
                case 'modal':
                    name = 'isLoadingModal';
                    break;
                case 'modalSet':
                    name = 'isLoadingModalSet';

                    break;
                default:
                    name = 'isLoading';
            }
        }
        container.setState({[name]: true, errorSelectInput: false, errorModal: false});
        axios.post(global.UrlWebService125, formData, {
            headers: {
                'Content-Type': 'multipart/form-data; charset=utf-8;',
                // 'Content-Type': 'application/json',
                //  "Authorization": `Basic ${base64.encode(params.username + ':' + params.password)}`
            },
            timeout: typeExport._TIMEOUT,
        })
            .then(async response => {

                if (container.state.typeMenu === 3 && response.data.success) {
                    container.saveOfflineTask();
                    // let arr = await AsyngStorageClass.getASyng(global.IdCity + "ListMessageHistoryOperatorFireScreen")
                    //
                    // arr = arr ? arr : []
                    // arr.push(this.props.route.params.item)
                    // await AsyngStorageClass.setAsyng(global.IdCity + "ListMessageHistoryOperatorFireScreen", arr)
                    //
                    // global.RefreshListOperatorFireApplyScreen = true;
                }

                if (response.data.success) {

                    func(response.data);
                    container.setState({[name]: false, errorSelectInput: false, errorModal: false, [nameError]: false});

                }
                else {
                    container.setState({
                        [name]: false,
                        errorSelectInput: type == 'selectInput' ? true : false,
                        [errorModal]: true,
                        [nameError]: true,
                    });

                }

                if (response.data.success && response.data.result && response.data.result.list) {

                }
                else {
                    if (type != 'modal') {
                        HMAlert(i18n.t('constant.message'),
                            (type !== 'selectInput') ? (response.data.result ? response.data.result : (response.data.error ? response.data.error.message : i18n.t('constant.retry'))) : i18n.t('constant.retry'),
                            [
                                // {text: 'Ask me later', onPress: () => {}},
                                {
                                    text: i18n.t('constant.ok'),
                                    onPress: () => {


                                        if (response.data.success) {
                                            this.setState({visibleModalMenu: ShowModal});
                                            if (this.state.typeMenu == 3) {
                                                NavigationService.BackTo(1);
                                            }
                                        }
                                        else {

                                        }
                                    },
                                },
                            ]);
                    }
                }

                let data = response.data;


                this.setState({[name]: false});

            }).catch((e) => {
            container.setState({
                [name]: false,
                errorSelectInput: type == 'selectInput' ? true : false,
                errorModal: true,
                [nameError]: true,
            });
            HMAlert(i18n.t('constant.message'),
                i18n.t('constant.retry'),
                [
                    // {text: 'Ask me later', onPress: () => {}},
                    {
                        text: i18n.t('constant.ok'),
                        onPress: () => {

                        },
                    },
                ]);
            console.log('error', e);
        });

    }
}

const styles = StyleSheet.create({
    /* container: {
         marginVertical: 5,
         borderRadius: 4,
         borderStyle: 'solid',
         borderWidth: 2,
         borderColor: Colors.green,
         backgroundColor: Colors.white,
         flex: 0,
         height: 'auto',
         overflow: 'hidden'
     },*/
    input: {
        height: moderateScale(100),
        backgroundColor: Colors.white,
        fontWeight: '600',
        fontSize: 11,
    },
    contain: {
        flex: 1,
        height: 150,
        width: '100%',
        // height: "100%",
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
    },


    container: {
        paddingHorizontal: BASE_PADDING,
    },
    closeButton: {
        color: 'white',
        borderWidth: 1,
        borderColor: 'white',
        padding: 8,
        borderRadius: 3,
        textAlign: 'center',
        margin: 10,
        alignSelf: 'flex-end',
    },
    customHeaderBox: {
        height: 150,
        backgroundColor: '#6C7A89',
        justifyContent: 'center',
        alignItems: 'center',
    },
    row: {
        flexDirection: 'row',
        marginLeft: -BASE_PADDING,
        marginRight: -BASE_PADDING,
    },
    col: {
        flex: 1,
    },
    square: {
        //  width: WINDOW_WIDTH ,
        // height: WINDOW_WIDTH ,
        justifyContent: 'center',
        alignSelf: 'center',
    },
    squareFirst: {
        backgroundColor: '#C0392B',
    },
    squareSecond: {
        backgroundColor: '#019875',
    },
    squareText: {
        textAlign: 'center',
        color: 'white',
    },
    carousel: {
        height: WINDOW_WIDTH - BASE_PADDING * 2,
        width: WINDOW_WIDTH - BASE_PADDING * 2,
        backgroundColor: 'white',
    },
    text: {
        marginVertical: BASE_PADDING * 2,
    },
    /* size: {
         input: moderateScale(100),
         icon: 20
     }*/
});

